// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import {
//   FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck, FaInfoCircle
// } from "react-icons/fa";

// import "bootstrap/dist/css/bootstrap.min.css";

// const styles = {
//   gradientText: {
//     background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: "600",
//   },
//   cardHeader: {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #e9ecef",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "1rem 1.5rem",
//   },
//   modalSection: {
//     border: "1px solid #dee2e6",
//     borderRadius: "0.375rem",
//     padding: "1.5rem",
//     marginBottom: "1.5rem",
//     backgroundColor: "#f8f9fa",
//   },
//   infoBox: {
//     backgroundColor: "#f0f7ff",
//     border: "1px solid #cfe2ff",
//     borderRadius: "0.5rem",
//     padding: "15px",
//     marginBottom: "20px",
//     fontSize: "0.85rem",
//     boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//   },
//   signaturePreview: {
//     maxWidth: "200px",
//     maxHeight: "100px",
//     border: "2px dashed #ced4da",
//     padding: "10px",
//     borderRadius: "0.375rem",
//     backgroundColor: "#ffffff",
//     marginTop: "15px",
//     display: "block",
//     marginLeft: "auto",
//     marginRight: "auto",
//     objectFit: "contain",
//   },
//   pageWrapper: { display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" },
//   contentWrapper: { display: "flex", flexGrow: 1, overflow: "hidden" },
//   mainContentArea: {
//     flexGrow: 1,
//     overflowY: "auto",
//     padding: "1.5rem 2rem",
//     backgroundColor: "#f4f7fc",
//     height: "calc(100vh - 56px)",
//   },
//   reactSelectStyles: {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
//       backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
//     }),
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//   },
// };

// const AppointmentLetterGenerator = () => {
//   const [letters, setLetters] = useState([])
//   const navigate = useNavigate()
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredLetters, setFilteredLetters] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [itemsPerPage, setItemsPerPage] = useState(10)
//   const [isLoading, setIsLoading] = useState(false)
//   const [isLoadingData, setIsLoadingData] = useState(true)
//   const [sentStatus, setSentStatus] = useState({})
//   const [isDownloading, setIsDownloading] = useState({})
//   const [isSending, setIsSending] = useState({})
  
//   const [showModal, setShowModal] = useState(false)
//   const [generationMethod, setGenerationMethod] = useState("custom")
//   const [customContent, setCustomContent] = useState("")
//   const [uploadedFile, setUploadedFile] = useState(null)
//   const [signatureFile, setSignatureFile] = useState(null)
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)

//   const [offerLettersSource, setOfferLettersSource] = useState([]) 
//   const [jobTitles, setJobTitles] = useState([])
//   const [hrList, setHrList] = useState([])
//   const [allDetailedApplicants, setAllDetailedApplicants] = useState([]); 

//   const [selectedJobTitle, setSelectedJobTitle] = useState("")
//   const [selectedCandidate, setSelectedCandidate] = useState(null)
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])

//   const [initialFormData] = useState({
//     candidateName: "",
//     position: "",
//     date: "",
//     section: "Appointment Letter",
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/");
//       const data = Array.isArray(response.data) ? response.data : (response.data?.letters || []);
//       setLetters(data);
//       const status = {};
//       data.forEach(l => status[l.id] = l.sent === true || l.sent === "true");
//       setSentStatus(status);
//     } catch (error) { console.error("Error fetching letters:", error); }
//   }, []);

//   const fetchDetailedApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
//       setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
//     } catch (error) { console.error("Error fetching detailed applicants:", error); }
//   }, []);

//   const fetchOfferLettersSource = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = Array.isArray(response.data) ? response.data : (response.data?.letters || []);
//       setOfferLettersSource(data);
//       setJobTitles([...new Set(data.map(item => item.position).filter(Boolean))].sort());
//     } catch (error) { console.error("Error fetching sources:", error); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       if (Array.isArray(response.data)) setHrList(response.data);
//     } catch (error) { console.error("Error fetching HR:", error); }
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       setIsLoadingData(true);
//       await Promise.all([fetchLetters(), fetchOfferLettersSource(), fetchHrList(), fetchDetailedApplicants()]);
//       setIsLoadingData(false);
//     };
//     load();
//   }, [fetchLetters, fetchOfferLettersSource, fetchHrList, fetchDetailedApplicants]);

//   useEffect(() => {
//     const filtered = letters.filter(l => 
//       l.candidate_name?.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredLetters(filtered);
//   }, [letters, searchQuery]);

//   const handleCandidateChange = useCallback((selectedOption) => {
//     setSelectedCandidate(selectedOption);
//     const applicantId = selectedOption?.value || null;
    
//     // Exact matching logic from the Offer Letter code
//     const detailedApp = allDetailedApplicants.find(app => 
//         (applicantId && String(app.user) === String(applicantId))
//     );

//     let candAddress = "N/A", candPin = "N/A", candPhone = "N/A";

//     if (detailedApp) {
//         // Constructing full address using exact parts list from Offer Letter code
//         const addrParts = [
//             detailedApp.address_type,
//             detailedApp.village, 
//             detailedApp.tehsil, 
//             detailedApp.district, 
//             detailedApp.state, 
//             detailedApp.country
//         ].filter(part => 
//             part && 
//             String(part).trim() !== "" && 
//             String(part).toLowerCase() !== "null"
//         );
        
//         candAddress = addrParts.join(", ");
//         candPin = detailedApp.zip_code || "N/A";
//         candPhone = detailedApp.phone || "N/A";
//     } else if (selectedOption?.offerData) {
//         // Fallback to Offer Letter record if match not found in applicants API
//         candAddress = selectedOption.offerData.applicant_address || "N/A";
//         candPhone = selectedOption.offerData.applicant_phone || "N/A";
//     }

//     setFormData(prev => ({
//       ...prev,
//       candidateName: selectedOption?.label || "",
//       user_id: applicantId,
//       address: candAddress,
//       mobileNumber: candPhone,
//       pinCode: String(candPin)
//     }));
//   }, [allDetailedApplicants]);

//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (!formData.user_id || !selectedJobTitle) { 
//       Swal.fire("Error", "Please select Job and Candidate", "warning"); 
//       setIsLoading(false); return; 
//     }

//     const payload = new FormData();
//     try {
//       if (generationMethod === "custom") {
//         if (!formData.date || !formData.hr || !signatureFile || !customContent.trim()) {
//            Swal.fire("Error", "Please fill all required fields", "warning");
//            setIsLoading(false); return;
//         }
        
//         payload.append('letter_date', formData.date);
//         payload.append('job_title', selectedJobTitle);
//         payload.append('hr_name', formData.hr.name);
//         payload.append('signature', signatureFile, signatureFile.name);
//         payload.append('user_id', formData.user_id);
//         payload.append('candidate_name', formData.candidateName);
//         payload.append('letter_content', customContent);
//         payload.append('method', "Appointment Letter");

//         const response = await axios.post("https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/", payload);
        
//         Swal.fire({ title: "Success!", icon: "success", timer: 1000, showConfirmButton: false }).then(() => {
//           setShowModal(false);
//           fetchLetters();
//           // Handling large content and full address during redirection
//           navigate("/appointmentletter", { 
//             state: { 
//               ...formData, 
//               customContent, 
//               generationMethod: 'custom', 
//               signaturePreviewUrl, 
//               jobTitle: selectedJobTitle, 
//               letter_id: response.data.letter_id 
//             } 
//           });
//         });
//       } else {
//         payload.append('method', "Appointment Letter");
//         payload.append('jobTitle', selectedJobTitle);
//         payload.append('candidate', formData.candidateName);
//         payload.append('upload_pdf', uploadedFile);
//         payload.append('user_id', formData.user_id);
//         await axios.post("https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/", payload);
//         Swal.fire("Success", "Uploaded Successfully", "success");
//         setShowModal(false);
//         fetchLetters();
//       }
//     } catch (error) { 
//         Swal.fire("Error", error.response?.data?.error || "Process failed", "error"); 
//     }
//     finally { setIsLoading(false); }
//   }, [formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters]);

//   const handleSignatureFileChange = useCallback(async (e) => {
//     const file = e.target.files[0] || null;
//     if (!file) return;
//     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//     try {
//       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//       const processedFile = new File([processedBlob], `sig_${Date.now()}.png`, { type: "image/png" });
//       setSignatureFile(processedFile);
//       const reader = new FileReader();
//       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//       reader.readAsDataURL(processedBlob);
//     } catch (error) { Swal.fire("Error", "Signature processing failed", "error"); }
//   }, []);

//   const handleJobTitleChange = (e) => {
//     const title = e.target.value;
//     setSelectedJobTitle(title);
//     setSelectedCandidate(null);
//     setFormData(prev => ({ ...initialFormData, position: title }));
//     if (title) {
//       const relevant = offerLettersSource.filter(o => o.position === title);
//       const unique = [];
//       const seen = new Set();
//       relevant.forEach(o => {
//         if (!seen.has(o.user_id)) {
//           seen.add(o.user_id);
//           unique.push({ value: o.user_id, label: o.candidate_name, offerData: o });
//         }
//       });
//       setFilteredCandidateOptions(unique);
//     }
//   };

//   return (
//     <div style={styles.pageWrapper}>
//       <DashNavbar />
//       <div style={styles.contentWrapper}>
//         <Sidebar />
//         <main style={styles.mainContentArea}>
//           <Container fluid className="p-0">
//             <Card className="shadow-sm border-0 h-100">
//               <Card.Header style={styles.cardHeader}>
//                 <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
//                 <Button onClick={() => { setFormData(initialFormData); setCustomContent(""); setShowModal(true); }} variant="primary" size="sm"><FaPlus className="me-1" /> Create Letter</Button>
//               </Card.Header>
//               <Card.Body className="p-3">
//                 <InputGroup size="sm" className="mb-3" style={{ maxWidth: '300px' }}>
//                   <Form.Control placeholder="Search candidate..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//                   <InputGroup.Text><FaSearch /></InputGroup.Text>
//                 </InputGroup>
//                 <Table hover responsive className="small">
//                   <thead className="table-light">
//                     <tr><th>#</th><th>Candidate</th><th>Method</th><th className="text-center">PDF</th><th>Date</th><th className="text-center">Email</th><th className="text-center">Status</th></tr>
//                   </thead>
//                   <tbody>
//                     {filteredLetters.slice((currentPage-1)*itemsPerPage, currentPage*itemsPerPage).map((letter, idx) => (
//                       <tr key={letter.id}>
//                         <td>{(currentPage-1)*itemsPerPage + idx + 1}</td>
//                         <td>{letter.candidate_name}</td>
//                         <td><Badge bg={letter.generation_method === 'custom' ? 'info' : 'secondary'}>{letter.generation_method}</Badge></td>
//                         <td className="text-center"><Button size="sm" variant="link"><FaDownload /></Button></td>
//                         <td>{new Date(letter.created_at).toLocaleDateString()}</td>
//                         <td className="text-center"><Button size="sm" variant="link" disabled={sentStatus[letter.id]}><FaPaperPlane /></Button></td>
//                         <td className="text-center">{sentStatus[letter.id] ? <FcApproval size="20" /> : <FcHighPriority size="20" />}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           </Container>
//         </main>
//       </div>

//       <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" backdrop="static">
//         <Modal.Header closeButton><Modal.Title style={styles.gradientText}>New Appointment Letter</Modal.Title></Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmit} id="letterForm">
//             <div style={styles.modalSection}>
//               <Row>
//                 <Col md={4}><Form.Label className="small fw-bold">Method</Form.Label><Form.Select size="sm" value={generationMethod} onChange={e => setGenerationMethod(e.target.value)}><option value="custom">Custom Content</option><option value="upload">Upload PDF</option></Form.Select></Col>
//                 <Col md={4}><Form.Label className="small fw-bold">Job Title *</Form.Label><Form.Select size="sm" value={selectedJobTitle} onChange={handleJobTitleChange} required><option value="">Select Job</option>{jobTitles.map(t => <option key={t} value={t}>{t}</option>)}</Form.Select></Col>
//                 <Col md={4}><Form.Label className="small fw-bold">Candidate *</Form.Label><Select styles={styles.reactSelectStyles} options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange} isDisabled={!selectedJobTitle} placeholder="Select Candidate" /></Col>
//               </Row>
//             </div>

//             {formData.user_id && (
//               <div style={styles.infoBox}>
//                 <div className="fw-bold mb-2 text-primary border-bottom pb-1"><FaInfoCircle className="me-1"/> Candidate Information:</div>
//                 <Row className="gy-2">
//                   <Col md={12}><strong>Full Address:</strong> {formData.address}</Col>
//                   <Col md={6}><strong>Mobile:</strong> {formData.mobileNumber}</Col>
//                   <Col md={6}><strong>Pin Code:</strong> {formData.pinCode}</Col>
//                 </Row>
//               </div>
//             )}

//             {generationMethod === 'custom' ? (
//               <div style={styles.modalSection}>
//                 <Row className="mb-3">
//                   <Col md={4}><Form.Label className="small fw-bold">Letter Date *</Form.Label><Form.Control type="date" size="sm" value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} required /></Col>
//                   <Col md={8}><Form.Label className="small fw-bold">HR for Signature *</Form.Label><Select styles={styles.reactSelectStyles} options={hrList.map(h => ({ value: h.id, label: h.name }))} onChange={opt => setFormData({...formData, hr: hrList.find(h => h.id === opt.value)})} placeholder="Select HR" /></Col>
//                 </Row>
//                 <Form.Label className="small fw-bold">Letter Body Content (Supports Large Content) *</Form.Label>
//                 <Form.Control as="textarea" rows={15} value={customContent} onChange={e => setCustomContent(e.target.value)} placeholder="Write your full letter content here..." required />
//                 <Form.Group className="mt-4 border-top pt-3">
//                   <Form.Label className="small fw-bold">Signature Image *</Form.Label>
//                   <Form.Control type="file" size="sm" accept="image/*" onChange={handleSignatureFileChange} required />
//                   {signaturePreviewUrl && <img src={signaturePreviewUrl} style={styles.signaturePreview} alt="Sig" />}
//                 </Form.Group>
//               </div>
//             ) : (
//               <div style={styles.modalSection}>
//                 <Form.Label className="small fw-bold">PDF File *</Form.Label>
//                 <Form.Control type="file" accept=".pdf" onChange={e => setUploadedFile(e.target.files[0])} required />
//               </div>
//             )}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)} size="sm">Cancel</Button>
//           <Button variant="primary" type="submit" form="letterForm" size="sm" disabled={isLoading}>{isLoading ? <Spinner size="sm" animation="border" /> : "Save & Generate"}</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default AppointmentLetterGenerator;





import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
import Swal from "sweetalert2";
import { FcApproval, FcHighPriority } from "react-icons/fc";
import Select from "react-select";
import { removeBackground } from "@imgly/background-removal";
import {
  FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck,
  FaSignature, FaFilePdf, FaInfoCircle, FaCalendar,
} from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";

const CustomStyles = () => (
  <style>{`
    .appointment-letter-page .card { flex: 1; display: flex; flex-direction: column; overflow: hidden; border: none; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); margin-bottom: 0 !important; }
    .appointment-letter-page .card-body { flex: 1; overflow-y: auto; display: flex; flex-direction: column; padding: 0 !important; }
    .appointment-letter-page .table-container { flex: 1; overflow-y: auto; padding: 0 1.5rem; }
    .appointment-letter-page .card-header { background: white; border-bottom: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    .appointment-letter-page .card-footer { background: white; border-top: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    
    /* Compact Table Styling */
    .appointment-letter-page .table td { padding: 8px 12px !important; font-size: 14px; }
    .appointment-letter-page .table th { padding: 12px !important; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; }
    .appointment-letter-page .search-container { padding: 1rem 1.5rem; flex-shrink: 0; }
  `}</style>
);

const styles = {
  gradientText: {
    background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "600",
  },
  cardHeader: {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e9ecef",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 1.5rem",
  },
  modalSection: {
    border: "1px solid #dee2e6",
    borderRadius: "0.375rem",
    padding: "1.5rem",
    marginBottom: "1.5rem",
    backgroundColor: "#f8f9fa",
  },
  signaturePreview: {
    maxWidth: "200px",
    maxHeight: "100px",
    border: "2px dashed #ced4da",
    padding: "10px",
    borderRadius: "0.375rem",
    backgroundColor: "#ffffff",
    marginTop: "15px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    objectFit: "contain",
  },
  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
  },
  contentWrapper: {
    display: "flex",
    flexGrow: 1,
    overflow: "hidden",
  },
  mainContentArea: {
    flexGrow: 1,
    overflowY: "auto",
    padding: "1.5rem 2rem",
    backgroundColor: "#f4f7fc",
    height: "calc(100vh - 56px)",
  },
  reactSelectStyles: {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
      boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
      "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
      minHeight: "38px",
      height: "auto",
      backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
    }),
    valueContainer: (provided) => ({ ...provided, padding: "2px 8px" }),
    input: (provided) => ({ ...provided, margin: "0px", padding: "0px" }),
    indicatorsContainer: (provided) => ({ ...provided, height: "38px" }),
    placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : null,
      color: state.isSelected ? "white" : "#212529",
      ":active": { backgroundColor: !state.isDisabled ? (state.isSelected ? "#0a58ca" : "#dbeafe") : undefined },
    }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "#6c757d" : "#212529",
    }),
  },
};

const AppointmentLetterGenerator = () => {
  const [letters, setLetters] = useState([])
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState("")
  const [filteredLetters, setFilteredLetters] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [noDataFound, setNoDataFound] = useState(false)
  const [sentStatus, setSentStatus] = useState({})
  const [isDownloading, setIsDownloading] = useState({})
  const [isSending, setIsSending] = useState({})
  
  const [showModal, setShowModal] = useState(false)
  const [generationMethod, setGenerationMethod] = useState("custom")
  const [customContent, setCustomContent] = useState("")
  const [uploadedFile, setUploadedFile] = useState(null)
  const [signatureFile, setSignatureFile] = useState(null)
  const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)
  const [isProcessingSignature, setIsProcessingSignature] = useState(false)

  const [offerLettersSource, setOfferLettersSource] = useState([]) 
  const [jobTitles, setJobTitles] = useState([])
  const [hrList, setHrList] = useState([])

  const [selectedJobTitle, setSelectedJobTitle] = useState("")
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])
  const [allDetailedApplicants, setAllDetailedApplicants] = useState([]);
  const [showApplicantData, setShowApplicantData] = useState(false)
  const [address, setAddress] = useState("")
  const [pinCode, setPinCode] = useState("")
  const [mobileNumber, setMobileNumber] = useState("")

  const [initialFormData] = useState({
    candidateName: "",
    position: "",
    date: "",
    section: "Appointment Letter",
    address: "",
    pinCode: "",
    mobileNumber: "",
    hr: null,
    user_id: null,
    joiningDate: "",
  });
  const [formData, setFormData] = useState(initialFormData);

  const initializeSentStatus = useCallback((lettersData) => {
    const initialSentStatus = {};
    lettersData.forEach((letter) => {
      initialSentStatus[letter.id] = letter.sent === true || letter.sent === "true";
    });
    setSentStatus(initialSentStatus);
  }, []);

  const fetchLetters = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/");
      const data = response.data;
      
      let lettersData = [];
      if (Array.isArray(data)) {
          lettersData = data;
      } else if (data && Array.isArray(data.letters)) {
          lettersData = data.letters;
      }

      if (lettersData.length > 0) {
        // Sort letters by created_at in descending order (newest first)
        const sortedLetters = lettersData.sort((a, b) => {
          const dateA = new Date(a.created_at || 0);
          const dateB = new Date(b.created_at || 0);
          return dateB - dateA;
        });
        setLetters(sortedLetters);
        initializeSentStatus(sortedLetters);
        setNoDataFound(false);
      } else {
        setLetters([]);
        setNoDataFound(true);
      }
    } catch (error) {
      console.error("Error fetching appointment letters:", error);
      setLetters([]);
      setNoDataFound(true);
    }
  }, [initializeSentStatus]);

  const fetchOfferLettersSource = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
      const data = response.data;
      
      let sourceData = [];
      if (Array.isArray(data)) {
        sourceData = data;
      } else if (data && Array.isArray(data.letters)) {
        sourceData = data.letters;
      }

      setOfferLettersSource(sourceData);

      const uniquePositions = [...new Set(sourceData.map(item => item.position).filter(Boolean))].sort();
      setJobTitles(uniquePositions);

    } catch (error) {
      console.error("Error fetching source offer letters:", error);
      setOfferLettersSource([]);
      setJobTitles([]);
    }
  }, []);

  const fetchHrList = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
      const data = response.data;
      if (data && Array.isArray(data)) { setHrList(data); }
      else { setHrList([]); }
    } catch (error) { console.error("Error fetching HR list:", error); }
  }, []);




  const fetchDetailedApplicants = useCallback(async () => {
    try {
      const response = await axios.get("https://raasbackend.vetrinahealthcare.com/api/applicants/");
      setAllDetailedApplicants(Array.isArray(response.data) ? response.data : []);
    } catch (error) { console.error("Error fetching detailed applicants:", error); }
  }, []);

  useEffect(() => {
    const loadInitialData = async () => {
      setIsLoadingData(true);
      try {
        await Promise.all([fetchLetters(), fetchOfferLettersSource(), fetchHrList(), fetchDetailedApplicants()]);
      } catch (error) {
        console.error("Error loading initial data:", error);
        Swal.fire("Load Error", "Failed to load necessary data.", "error");
      } finally {
        setIsLoadingData(false);
      }
    };
    loadInitialData();
  }, [fetchLetters, fetchOfferLettersSource, fetchHrList, fetchDetailedApplicants]);

  const applySearchAndPagination = useCallback(() => {
    let filteredData = letters.filter((letter) => {
      const searchLower = searchQuery.toLowerCase();
      const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
      const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
      return candidateMatches || methodMatches;
    });
    setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
    setFilteredLetters(filteredData);
  }, [letters, searchQuery]);

  useEffect(() => {
    applySearchAndPagination();
  }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

  const sendEmail = useCallback(async (candidateName, pdfPath, letterType, pk) => {
    if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
    
    let cleanPath = pdfPath;
    if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

    setIsSending(prev => ({ ...prev, [pk]: true }));
    try {
      await axios.post("https://raasbackend.vetrinahealthcare.com/send_appointment_letter_email/", {
        candidate_name: candidateName,
        pdf_path: cleanPath,
        letter_type: letterType || "Appointment Letter",
        letter_id: pk,
      });
      Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
      
      setLetters(prev => prev.map(l => l.id === pk ? {...l, sent: true} : l));
      setSentStatus(prev => ({ ...prev, [pk]: true }));

    } catch (error) {
      console.error("Error sending email:", error);
      Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true });
    }
    finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
  }, []);

  const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
    if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
    
    let cleanPath = pdfPath;
    if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

    setIsDownloading(prev => ({ ...prev, [pk]: true }));
    try {
      const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_appointment_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { params:{pdf_path: cleanPath,letter_id:pk,}, responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      const filename = `${candidateName}_${letterType || 'Appointment'}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
      link.setAttribute("download", filename);
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
    finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  }, []);

  const handleHrChange = useCallback((selectedOption) => {
    const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
    setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
  }, [hrList]);

  const handleFileChange = useCallback((e) => {
    setUploadedFile(e.target.files[0] || null);
  }, []);

  const handleSignatureFileChange = useCallback(async (e) => {
    const file = e.target.files[0] || null;
    setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
      if (e?.target) e.target.value = null;
      return;
    }
    setIsProcessingSignature(true);
    Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    try {
      const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
      const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
      setSignatureFile(processedFile);
      const reader = new FileReader();
      reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
      reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
      reader.readAsDataURL(processedBlob);
    } catch (error) {
      console.error("Error removing background:", error);
      Swal.fire({ icon: "error", title: "Background Removal Failed", text: "Could not process signature." });
      setSignatureFile(null); setSignaturePreviewUrl(null);
      if (e?.target) e.target.value = null;
    } finally {
      setIsProcessingSignature(false);
      if (Swal.isVisible()) { Swal.close(); }
    }
  }, []);

  const handleJobTitleChange = useCallback((event) => {
    const title = event.target.value;
    setSelectedJobTitle(title);
    setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
    setFormData(prev => ({ ...initialFormData, position: title || '', generationMethod: prev.generationMethod }));
    
    if (title && offerLettersSource.length > 0) {
      const relevantOffers = offerLettersSource.filter(offer => offer.position === title);
      const uniqueCandidates = [];
      const seenUserIds = new Set();

      relevantOffers.forEach(offer => {
          if (!seenUserIds.has(offer.user_id)) {
              seenUserIds.add(offer.user_id);
              uniqueCandidates.push({
                  value: offer.user_id,
                  label: offer.candidate_name,
                  fullName: offer.candidate_name,
                  offerData: offer
              });
          }
      });

      uniqueCandidates.sort((a, b) => a.label.localeCompare(b.label));
      setFilteredCandidateOptions(uniqueCandidates);
    }
  }, [offerLettersSource, initialFormData]);

  const handleCandidateChange = useCallback((selectedOption) => {
    setSelectedCandidate(selectedOption);
    const applicantId = selectedOption?.value || null;
    
    // MATCHING APPLICANTS DATA FOR DETAILED ADDRESS
    const detailedApp = allDetailedApplicants.find(app => 
        (applicantId && String(app.user) === String(applicantId))
    );

    let candAddress = "N/A", candPin = "N/A", candPhone = "N/A";

    if (detailedApp) {
        // Construct detailed address exactly like Offer Letter format
        const addrParts = [
            detailedApp.address_type,
            detailedApp.village, 
            detailedApp.tehsil, 
            detailedApp.district, 
            detailedApp.state, 
            detailedApp.country
        ].filter(part => part && String(part).trim() !== "" && String(part).toLowerCase() !== "null");
        
        candAddress = addrParts.join(", ");
        candPin = detailedApp.zip_code || "N/A";
        candPhone = detailedApp.phone || "N/A";
    } else if (selectedOption?.offerData) {
        candAddress = selectedOption.offerData.applicant_address || "N/A";
        candPhone = selectedOption.offerData.applicant_phone || "N/A";
        const pinMatch = candAddress.match(/\b\d{6}\b/);
        candPin = pinMatch ? pinMatch[0] : "N/A";
    }

    setAddress(candAddress);
    setPinCode(String(candPin));
    setMobileNumber(candPhone);
    setShowApplicantData(true);

    setFormData(prevState => ({
      ...prevState,
      candidateName: selectedOption?.fullName || "",
      user_id: applicantId,
      address: candAddress,
      mobileNumber: candPhone,
      pinCode: String(candPin)
    }));
  }, [allDetailedApplicants]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a candidate.", "warning"); setIsLoading(false); return; }
    if (!selectedJobTitle) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }

    let endpoint = "";
    const payload = new FormData();
    let headers = { 'Content-Type': 'multipart/form-data' };
    let navigateTo = null;
    let navigateState = null;
    let successMessage = "";

    try {
      if (generationMethod === "custom") {
        if (!formData.date) { Swal.fire("Validation Error", "Please select a Letter Date.", "warning"); setIsLoading(false); return; }
        if (!formData.hr) { Swal.fire("Validation Error", "Please select an HR for the signature.", "warning"); setIsLoading(false); return; }
        if (!signatureFile) { Swal.fire("Validation Error", "Please upload a signature image.", "warning"); setIsLoading(false); return; }
        if (!customContent.trim()) { Swal.fire("Validation Error", "Please enter custom letter content.", "warning"); setIsLoading(false); return; }
        
        endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/";
        
        payload.append('letter_date', formData.date);
        payload.append('job_title', selectedJobTitle);
        payload.append('hr_name', formData.hr.name);
        payload.append('signature', signatureFile, signatureFile.name);
        
        // Additional info
        payload.append('method', "Appointment Letter");
        payload.append('user_id', formData.user_id);
        payload.append('candidate_name', formData.candidateName);
        
        // KEY CHANGE HERE: Backend specifically expects 'letter_content'
        payload.append('letter_content', customContent);
        
        if (formData.hr?.id) payload.append('hr_id', formData.hr.id);

        const response = await axios.post(endpoint, payload, { headers });
        const createdLetterId = response.data.letter_id;
        
        successMessage = response.data.message || `Custom Appointment Letter record created.`;
        navigateTo = "/appointmentletter";
        navigateState = {
          ...formData,
          customContent,
          section: "Appointment Letter",
          generationMethod: 'custom',
          signaturePreviewUrl,
          jobTitle: selectedJobTitle,
          letter_id: createdLetterId,
        };

      } else if (generationMethod === "upload") {
        if (!uploadedFile) { Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning"); setIsLoading(false); return; }
        
        endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/";
        
        payload.append('method', "Appointment Letter");
        payload.append('jobTitle', selectedJobTitle);
        payload.append('candidate', formData.candidateName);
        payload.append('upload_pdf', uploadedFile);
        payload.append('user_id', formData.user_id);

        const response = await axios.post(endpoint, payload, { headers });
        successMessage = response.data.message || `Existing Appointment Letter uploaded.`;
        navigateTo = null;
        navigateState = null;

      } else { throw new Error("Invalid generation method selected."); }

      Swal.fire({
        title: "Success!", text: successMessage, icon: "success",
        timer: navigateTo ? 1500 : 2500,
        timerProgressBar: true, showConfirmButton: false,
      }).then(() => {
        handleCloseModal();
        fetchLetters();
        if (navigateTo) {
          navigate(navigateTo, { state: navigateState });
        }
      });

    } catch (error) {
      console.error(`Error during ${generationMethod} process:`, error);
      let errorMsg = "An error occurred.";
      if (error.response && error.response.data) {
        errorMsg = error.response.data.error || error.response.data.error_message || error.response.data.message || JSON.stringify(error.response.data);
      }
      Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
    } finally {
      setIsLoading(false);
    }
  }, [formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters]);

  const handleOpenModal = useCallback(() => {
    setSelectedJobTitle(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null);
    setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
    setGenerationMethod("custom"); setCustomContent(""); setUploadedFile(null);
    setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
    const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
    const fileInputSignatureCustom = document.getElementById('signatureImageFileCustom'); if (fileInputSignatureCustom) fileInputSignatureCustom.value = null;
    setShowModal(true);
  }, [initialFormData]);

  const handleCloseModal = useCallback(() => { setShowModal(false); }, []);

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return <span className="text-muted small">N/A</span>;
    const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
    try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
  };
  const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
  const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

  const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
  const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

  const getPageOptions = () => [5, 10, 25, 50, 100];

  const renderPaginationFooter = () => {
    if (isLoadingData || letters.length === 0) return null;
    
    const totalItems = filteredLetters.length;
    const startRecord = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const endRecord = Math.min(currentPage * itemsPerPage, totalItems);

    return (
      <div className="card-footer d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalItems}</b> records
        </div>
        
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span className="text-muted small">Rows:</span>
            <Form.Select 
              size="sm" 
              value={itemsPerPage} 
              onChange={handleItemsPerPageChange}
              style={{ width: "70px" }}
            >
              {getPageOptions().map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </Form.Select>
          </div>

          <Pagination size="sm" className="mb-0">
            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
            <Pagination.Item active>{currentPage}</Pagination.Item>
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0} />
            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages || totalPages === 0} />
          </Pagination>
        </div>
      </div>
    );
  };

  return (
    <>
      <div style={styles.pageWrapper}>
        <DashNavbar />
        <div style={styles.contentWrapper}>
          <Sidebar />
          <main style={styles.mainContentArea}>
            <Container fluid className="p-0">
              <Card className="shadow-sm border-0 h-100">
                <Card.Header style={styles.cardHeader}>
                  <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
                  <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
                    {isLoadingData ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />) : (<FaPlus className="me-1" />)}
                    Create Appointment Letter
                  </Button>
                </Card.Header>

                <Card.Body>
                  <CustomStyles />
                  <div className="search-container">
                    <Row>
                      <Col md={7} lg={5}>
                        <InputGroup size="sm">
                          <Form.Control type="search" placeholder="Search by Candidate, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
                          <InputGroup.Text><FaSearch /></InputGroup.Text>
                        </InputGroup>
                      </Col>
                    </Row>
                  </div>

                  <div className="table-container">
                    <Table hover responsive className="align-middle mb-0 small">
                      <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
                        <tr>
                          <th style={{ width: '5%' }}>#</th>
                          <th style={{ width: '35%' }}>Candidate Name</th>
                          <th style={{ width: '15%' }}>Method</th>
                          <th style={{ width: '10%' }} className="text-center">Download</th>
                          <th style={{ width: '20%' }}>Generated On</th>
                          <th style={{ width: '10%' }} className="text-center">Send Email</th>
                          <th style={{ width: '5%' }} className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoadingData ? (
                          <tr><td colSpan="7" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading appointment letters...</p></td></tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((letter, index) => {
                            const globalIndex = indexOfFirstItem + index;
                            const pk = letter.id; 
                            const isSent = sentStatus[pk];
                            const method = letter.generation_method || 'N/A';
                            const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
                            const methodBg = method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                            
                            return (
                              <tr key={pk}>
                                <td>{globalIndex + 1}</td>
                                <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
                                <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
                                <td className="text-center">
                                  <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, "Appointment Letter")} disabled={isDownloading[pk] || !letter.pdf_path}>
                                    {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
                                  </Button>
                                </td>
                                <td>{formatDateTime(letter.created_at)}</td>
                                <td className="text-center">
                                  <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, "Appointment Letter", pk)} disabled={isSending[pk] || isSent || !letter.pdf_path}>
                                    {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
                                  </Button>
                                </td>
                                <td className="text-center">
                                  {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr><td colSpan="7" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No appointment letters have been generated yet."}</td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  {renderPaginationFooter()}
                </Card.Body>
              </Card>
            </Container>
          </main>
        </div>

        <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title style={styles.gradientText}>
              Create New Appointment Letter
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
            <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
              <div style={styles.modalSection}>
                <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
                <Row>
                  <Col md={6} lg={4} className="mb-3">
                    <Form.Group controlId="generationMethod">
                      <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
                      <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
                        <option value="custom">Write Custom Content</option>
                        <option value="upload">Upload Existing PDF</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group controlId="jobTitleSelect">
                      <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
                      <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
                        <option value="">-- Select Job --</option>
                        {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group controlId="candidateNameSelect">
                      <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
                      <Select
                        styles={styles.reactSelectStyles}
                        options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
                        placeholder={selectedJobTitle ? "Search candidate..." : "Select job title first"}
                        isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                {showApplicantData && (
                    <Alert variant="secondary" className="p-2 small mt-2 mb-0">
                        <FaInfoCircle className="me-1"/> <strong>Full Address:</strong> {address || 'N/A'}, <strong>Pin:</strong> {pinCode || 'N/A'}, <strong>Ph:</strong> {mobileNumber || 'N/A'}
                    </Alert>
                )}
              </div>

              <div style={styles.modalSection}>
                <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details</h5>

                {generationMethod === 'custom' && (
                  <>
                    <Row>
                      <Col md={6} lg={4} className="mb-3">
                        <Form.Group controlId="dateCustom">
                          <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
                          <InputGroup size="sm">
                              <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required id="dateCustomInput" />
                              <InputGroup.Text 
                                  style={{ cursor: 'pointer' }} 
                                  onClick={() => { document.getElementById('dateCustomInput').showPicker(); }}
                              >
                                  <FaCalendar className="text-primary"/>
                              </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col md={6} lg={8} className="mb-3">
                        <Form.Group controlId="hrNameSelectCustom">
                          <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
                          <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-3" controlId="customContentArea">
                      <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
                      <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} required />
                    </Form.Group>
                    <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
                      <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <span className="text-danger">*</span></Form.Label>
                      <Form.Control type="file" accept="image/*" onChange={handleSignatureFileChange} disabled={isProcessingSignature} size="sm" />
                      {signaturePreviewUrl && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Preview" style={styles.signaturePreview} /></div>}
                    </Form.Group>
                  </>
                )}
                {generationMethod === 'upload' && (
                  <Form.Group controlId="uploadedFile" className="mb-3">
                    <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm" />
                  </Form.Group>
                )}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-light border-top">
            <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading} size="sm"> Cancel </Button>
            <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
              {isLoading ? <Spinner as="span" animation="border" size="sm" /> : "Save & Generate"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default AppointmentLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import {
//   FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck,
//   FaSignature, FaFilePdf, FaInfoCircle,
// } from "react-icons/fa";

// import "bootstrap/dist/css/bootstrap.min.css";

// const styles = {
//   gradientText: {
//     background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: "600",
//   },
//   cardHeader: {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #e9ecef",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "1rem 1.5rem",
//   },
//   modalSection: {
//     border: "1px solid #dee2e6",
//     borderRadius: "0.375rem",
//     padding: "1.5rem",
//     marginBottom: "1.5rem",
//     backgroundColor: "#f8f9fa",
//   },
//   signaturePreview: {
//     maxWidth: "200px",
//     maxHeight: "100px",
//     border: "2px dashed #ced4da",
//     padding: "10px",
//     borderRadius: "0.375rem",
//     backgroundColor: "#ffffff",
//     marginTop: "15px",
//     display: "block",
//     marginLeft: "auto",
//     marginRight: "auto",
//     objectFit: "contain",
//   },
//   pageWrapper: {
//     display: "flex",
//     flexDirection: "column",
//     height: "100vh",
//     overflow: "hidden",
//   },
//   contentWrapper: {
//     display: "flex",
//     flexGrow: 1,
//     overflow: "hidden",
//   },
//   mainContentArea: {
//     flexGrow: 1,
//     overflowY: "auto",
//     padding: "1.5rem 2rem",
//     backgroundColor: "#f4f7fc",
//     height: "calc(100vh - 56px)",
//   },
//   reactSelectStyles: {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
//       "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
//       minHeight: "38px",
//       height: "auto",
//       backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
//     }),
//     valueContainer: (provided) => ({ ...provided, padding: "2px 8px" }),
//     input: (provided) => ({ ...provided, margin: "0px", padding: "0px" }),
//     indicatorsContainer: (provided) => ({ ...provided, height: "38px" }),
//     placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : null,
//       color: state.isSelected ? "white" : "#212529",
//       ":active": { backgroundColor: !state.isDisabled ? (state.isSelected ? "#0a58ca" : "#dbeafe") : undefined },
//     }),
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//     singleValue: (provided, state) => ({
//       ...provided,
//       color: state.isDisabled ? "#6c757d" : "#212529",
//     }),
//   },
// };

// const AppointmentLetterGenerator = () => {
//   const [letters, setLetters] = useState([])
//   const navigate = useNavigate()
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredLetters, setFilteredLetters] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [itemsPerPage, setItemsPerPage] = useState(10)
//   const [isLoading, setIsLoading] = useState(false)
//   const [isLoadingData, setIsLoadingData] = useState(true)
//   const [noDataFound, setNoDataFound] = useState(false)
//   const [sentStatus, setSentStatus] = useState({})
//   const [isDownloading, setIsDownloading] = useState({})
//   const [isSending, setIsSending] = useState({})
  
//   const [showModal, setShowModal] = useState(false)
//   const [generationMethod, setGenerationMethod] = useState("custom")
//   const [customContent, setCustomContent] = useState("")
//   const [uploadedFile, setUploadedFile] = useState(null)
//   const [signatureFile, setSignatureFile] = useState(null)
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false)

//   const [offerLettersSource, setOfferLettersSource] = useState([]) 
//   const [jobTitles, setJobTitles] = useState([])
//   const [hrList, setHrList] = useState([])

//   const [selectedJobTitle, setSelectedJobTitle] = useState("")
//   const [selectedCandidate, setSelectedCandidate] = useState(null)
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])
//   const [showApplicantData, setShowApplicantData] = useState(false)
//   const [address, setAddress] = useState("")
//   const [pinCode, setPinCode] = useState("")
//   const [mobileNumber, setMobileNumber] = useState("")

//   const [initialFormData] = useState({
//     candidateName: "",
//     position: "",
//     date: "",
//     section: "Appointment Letter",
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//     joiningDate: "",
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/");
//       const data = response.data;
      
//       let lettersData = [];
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else {
//         setLetters([]);
//         setNoDataFound(true);
//       }
//     } catch (error) {
//       console.error("Error fetching appointment letters:", error);
//       setLetters([]);
//       setNoDataFound(true);
//     }
//   }, []);

//   const fetchOfferLettersSource = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;
      
//       let sourceData = [];
//       if (Array.isArray(data)) {
//         sourceData = data;
//       } else if (data && Array.isArray(data.letters)) {
//         sourceData = data.letters;
//       }

//       setOfferLettersSource(sourceData);

//       const uniquePositions = [...new Set(sourceData.map(item => item.position).filter(Boolean))].sort();
//       setJobTitles(uniquePositions);

//     } catch (error) {
//       console.error("Error fetching source offer letters:", error);
//       setOfferLettersSource([]);
//       setJobTitles([]);
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true || letter.sent === "true";
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//         await Promise.all([fetchLetters(), fetchOfferLettersSource(), fetchHrList()]);
//       } catch (error) {
//         console.error("Error loading initial data:", error);
//         Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//         setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchOfferLettersSource, fetchHrList]);

//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//   const sendEmail = useCallback(async (candidateName, pdfPath, letterType, pk) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
    
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsSending(prev => ({ ...prev, [pk]: true }));
//     try {
//       await axios.post("https://raasbackend.vetrinahealthcare.com/send_appointment_letter_email/", {
//         candidate_name: candidateName,
//         pdf_path: cleanPath,
//         letter_type: letterType || "Appointment Letter",
//         letter_id: pk,
//       });
//       Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
      
//       setLetters(prev => prev.map(l => l.id === pk ? {...l, sent: true} : l));
//       setSentStatus(prev => ({ ...prev, [pk]: true }));

//     } catch (error) {
//       console.error("Error sending email:", error);
//       Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true });
//     }
//     finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
    
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsDownloading(prev => ({ ...prev, [pk]: true }));
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_appointment_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
//       const link = document.createElement("a");
//       link.href = url;
//       const filename = `${candidateName}_${letterType || 'Appointment'}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//       link.setAttribute("download", filename);
//       document.body.appendChild(link); link.click(); document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//     finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({ ...prevState, [name]: value }));
//   }, []);

//   const handleHrChange = useCallback((selectedOption) => {
//     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//     setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//   }, [hrList]);

//   const handleFileChange = useCallback((e) => {
//     setUploadedFile(e.target.files[0] || null);
//   }, []);

//   const handleSignatureFileChange = useCallback(async (e) => {
//     const file = e.target.files[0] || null;
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//       if (e?.target) e.target.value = null;
//       return;
//     }
//     setIsProcessingSignature(true);
//     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//     try {
//       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//       const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//       setSignatureFile(processedFile);
//       const reader = new FileReader();
//       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//       reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//       reader.readAsDataURL(processedBlob);
//     } catch (error) {
//       console.error("Error removing background:", error);
//       Swal.fire({ icon: "error", title: "Background Removal Failed", text: "Could not process signature." });
//       setSignatureFile(null); setSignaturePreviewUrl(null);
//       if (e?.target) e.target.value = null;
//     } finally {
//       setIsProcessingSignature(false);
//       if (Swal.isVisible()) { Swal.close(); }
//     }
//   }, []);

//   const handleJobTitleChange = useCallback((event) => {
//     const title = event.target.value;
//     setSelectedJobTitle(title);
//     setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//     setFormData(prev => ({ ...initialFormData, position: title || '', generationMethod: prev.generationMethod }));
    
//     if (title && offerLettersSource.length > 0) {
//       const relevantOffers = offerLettersSource.filter(offer => offer.position === title);
//       const uniqueCandidates = [];
//       const seenUserIds = new Set();

//       relevantOffers.forEach(offer => {
//           if (!seenUserIds.has(offer.user_id)) {
//               seenUserIds.add(offer.user_id);
//               uniqueCandidates.push({
//                   value: offer.user_id,
//                   label: offer.candidate_name,
//                   fullName: offer.candidate_name,
//                   offerData: offer
//               });
//           }
//       });

//       uniqueCandidates.sort((a, b) => a.label.localeCompare(b.label));
//       setFilteredCandidateOptions(uniqueCandidates);
//     }
//   }, [offerLettersSource, initialFormData]);

//   const handleCandidateChange = useCallback((selectedOption) => {
//     setSelectedCandidate(selectedOption);
//     const applicantId = selectedOption?.value || null;
//     const applicantName = selectedOption?.fullName || selectedOption?.label || "";
    
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
    
//     setFormData(prevState => ({
//       ...prevState,
//       candidateName: applicantName,
//       user_id: applicantId
//     }));

//     if (selectedOption && selectedOption.offerData) {
//         const { applicant_address, applicant_phone } = selectedOption.offerData;
//         const fetchedAddress = applicant_address || "N/A";
//         const fetchedMobile = applicant_phone || "N/A";
//         const pinMatch = fetchedAddress.match(/\b\d{6}\b/);
//         const fetchedPinCode = pinMatch ? pinMatch[0] : "";

//         setAddress(fetchedAddress);
//         setPinCode(fetchedPinCode);
//         setMobileNumber(fetchedMobile);
//         setShowApplicantData(true);
        
//         setFormData(prevState => ({
//             ...prevState,
//             address: fetchedAddress,
//             pinCode: fetchedPinCode,
//             mobileNumber: fetchedMobile
//         }));
//     }
//   }, []);

//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//     if (!selectedJobTitle) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }

//     let endpoint = "";
//     const payload = new FormData();
//     let headers = { 'Content-Type': 'multipart/form-data' };
//     let navigateTo = null;
//     let navigateState = null;
//     let successMessage = "";

//     try {
//       if (generationMethod === "custom") {
//         if (!formData.date) { Swal.fire("Validation Error", "Please select a Letter Date.", "warning"); setIsLoading(false); return; }
//         if (!customContent.trim()) { Swal.fire("Validation Error", "Please enter custom letter content.", "warning"); setIsLoading(false); return; }
        
//         endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/";
        
//         payload.append('method', "Appointment Letter");
//         payload.append('user_id', formData.user_id);
//         payload.append('customContent', customContent);
//         payload.append('date', formData.date);
//         payload.append('candidate_name', formData.candidateName);
        
//         if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//         if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//         const response = await axios.post(endpoint, payload, { headers });
//         const createdLetterId = response.data.letter_id;
        
//         successMessage = response.data.message || `Custom Appointment Letter record created.`;
//         navigateTo = "/appointmentletter";
//         navigateState = {
//           ...formData,
//           customContent,
//           section: "Appointment Letter",
//           generationMethod: 'custom',
//           signaturePreviewUrl,
//           jobTitle: selectedJobTitle,
//           letter_id: createdLetterId,
//         };

//       } else if (generationMethod === "upload") {
//         if (!uploadedFile) { Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning"); setIsLoading(false); return; }
//         if (uploadedFile.type !== 'application/pdf') { Swal.fire("Validation Error", "Invalid file type. Please upload a PDF.", "warning"); setIsLoading(false); return; }

//         endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/";
        
//         payload.append('method', "Appointment Letter");
//         payload.append('jobTitle', selectedJobTitle);
//         payload.append('candidate', formData.candidateName);
//         payload.append('upload_pdf', uploadedFile);
//         payload.append('user_id', formData.user_id);

//         const response = await axios.post(endpoint, payload, { headers });
//         successMessage = response.data.message || `Existing Appointment Letter uploaded.`;
//         navigateTo = null;
//         navigateState = null;

//       } else { throw new Error("Invalid generation method selected."); }

//       Swal.fire({
//         title: "Success!", text: successMessage, icon: "success",
//         timer: navigateTo ? 1500 : 2500,
//         timerProgressBar: true, showConfirmButton: false,
//       }).then(() => {
//         handleCloseModal();
//         fetchLetters();
//         if (navigateTo) {
//           navigate(navigateTo, { state: navigateState });
//         }
//       });

//     } catch (error) {
//       console.error(`Error during ${generationMethod} process:`, error);
//       let errorMsg = error.message;
//       if (error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//       Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//     } finally {
//       setIsLoading(false);
//     }
//   }, [formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters]);

//   const handleOpenModal = useCallback(() => {
//     setSelectedJobTitle(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null);
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
//     setGenerationMethod("custom"); setCustomContent(""); setUploadedFile(null);
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//     const fileInputSignatureCustom = document.getElementById('signatureImageFileCustom'); if (fileInputSignatureCustom) fileInputSignatureCustom.value = null;
//     setShowModal(true);
//   }, [initialFormData]);

//   const handleCloseModal = useCallback(() => { setShowModal(false); }, []);

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//     const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//     try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//   };
//   const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//   const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//   const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//   const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//             <Container fluid className="p-0">
//               <Card className="shadow-sm border-0 h-100">
//                 <Card.Header style={styles.cardHeader}>
//                   <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
//                   <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                     {isLoadingData ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />) : (<FaPlus className="me-1" />)}
//                     Create Appointment Letter
//                   </Button>
//                 </Card.Header>

//                 <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                   <Row className="mb-4 flex-shrink-0">
//                     <Col md={7} lg={5}>
//                       <InputGroup size="sm">
//                         <Form.Control type="search" placeholder="Search by Candidate, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                         <InputGroup.Text><FaSearch /></InputGroup.Text>
//                       </InputGroup>
//                     </Col>
//                   </Row>

//                   <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                     <Table hover responsive className="align-middle mb-0 small">
//                       <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                         <tr>
//                           <th style={{ width: '5%' }}>#</th>
//                           <th style={{ width: '35%' }}>Candidate Name</th>
//                           <th style={{ width: '15%' }}>Method</th>
//                           <th style={{ width: '10%' }} className="text-center">Download</th>
//                           <th style={{ width: '20%' }}>Generated On</th>
//                           <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                           <th style={{ width: '5%' }} className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoadingData ? (
//                           <tr><td colSpan="7" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading appointment letters...</p></td></tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((letter, index) => {
//                             const globalIndex = indexOfFirstItem + index;
//                             const pk = letter.id; 
//                             const isSent = sentStatus[pk];
//                             const method = letter.generation_method || 'N/A';
//                             const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                             const methodBg = method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                            
//                             return (
//                               <tr key={pk}>
//                                 <td>{globalIndex + 1}</td>
//                                 <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                 <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, "Appointment Letter")} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                     {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                   </Button>
//                                 </td>
//                                 <td>{formatDateTime(letter.created_at)}</td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, "Appointment Letter", pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                     {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                   </Button>
//                                 </td>
//                                 <td className="text-center">
//                                   {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr><td colSpan="7" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No appointment letters have been generated yet."}</td></tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                     <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                       <div className="d-flex align-items-center">
//                         <span className="me-2 text-muted small">Rows:</span>
//                         <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                           <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                         </Form.Select>
//                         <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                       </div>
//                       <Pagination size="sm" className="mb-0">
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         <Pagination.Item active>{currentPage}</Pagination.Item>
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                         {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                         {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                       </Pagination>
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//           <Modal.Header closeButton>
//             <Modal.Title style={styles.gradientText}>
//               {generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               {generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               Create New Appointment Letter
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//             <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                 <Row>
//                   <Col md={6} lg={4} className="mb-3">
//                     <Form.Group controlId="generationMethod">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                         <option value="custom">Write Custom Content</option>
//                         <option value="upload">Upload Existing PDF</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="jobTitleSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
//                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
//                         <option value="">-- Select Job --</option>
//                         {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                       </Form.Select>
//                       {!isLoadingData && jobTitles.length === 0 && <Form.Text className="text-danger small">No job titles loaded.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="candidateNameSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                       <Select
//                         styles={styles.reactSelectStyles}
//                         options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                         placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                         isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                         noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                       />
//                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 {showApplicantData && (
//                   <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                     <FaInfoCircle className="me-1" /> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                   </Alert>
//                 )}
//               </div>

//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod === "custom" ? "Custom Content" : "Upload PDF"})</h5>

//                 {generationMethod === 'custom' && (
//                   <>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="dateCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={8} className="mb-3">
//                         <Form.Group controlId="hrNameSelectCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                           <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Form.Group className="mb-3" controlId="customContentArea">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                       <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the appointment letter here..." required />
//                     </Form.Group>
//                     <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                       <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFileCustom" disabled={isProcessingSignature} size="sm" />
//                       {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                       {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                       {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                     </Form.Group>
//                   </>
//                 )}
//                 {generationMethod === 'upload' && (
//                   <>
//                     <Alert variant="info" className="d-flex align-items-center small">
//                       <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em" />
//                       Upload the final, signed appointment letter as a PDF document. It will be stored and associated with the selected candidate.
//                     </Alert>
//                     <Form.Group controlId="uploadedFile" className="mb-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                       <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm" id="uploadedFile" />
//                       {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                     </Form.Group>
//                   </>
//                 )}
//               </div>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer className="bg-light border-top">
//             <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//             <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//               {isLoading || isProcessingSignature ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//               ) : generationMethod === 'upload' ? (<><FaFilePdf className="me-1" /> Upload {formData.section}</>
//               ) : (
//                 <><FaSignature className="me-1" /> Save & Preview {formData.section}</>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default AppointmentLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import {
//   FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck,
//   FaSignature, FaFilePdf, FaEdit, FaInfoCircle,
// } from "react-icons/fa";

// import "bootstrap/dist/css/bootstrap.min.css";

// // --- Professional Styles ---
// const styles = {
//   gradientText: {
//     background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: "600",
//   },
//   cardHeader: {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #e9ecef",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "1rem 1.5rem",
//   },
//   modalSection: {
//     border: "1px solid #dee2e6",
//     borderRadius: "0.375rem",
//     padding: "1.5rem",
//     marginBottom: "1.5rem",
//     backgroundColor: "#f8f9fa",
//   },
//   signaturePreview: {
//     maxWidth: "200px",
//     maxHeight: "100px",
//     border: "2px dashed #ced4da",
//     padding: "10px",
//     borderRadius: "0.375rem",
//     backgroundColor: "#ffffff",
//     marginTop: "15px",
//     display: "block",
//     marginLeft: "auto",
//     marginRight: "auto",
//     objectFit: "contain",
//   },
//   pageWrapper: {
//     display: "flex",
//     flexDirection: "column",
//     height: "100vh",
//     overflow: "hidden",
//   },
//   contentWrapper: {
//     display: "flex",
//     flexGrow: 1,
//     overflow: "hidden",
//   },
//   mainContentArea: {
//     flexGrow: 1,
//     overflowY: "auto",
//     padding: "1.5rem 2rem",
//     backgroundColor: "#f4f7fc",
//     height: "calc(100vh - 56px)",
//   },
//   reactSelectStyles: {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
//       "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
//       minHeight: "38px",
//       height: "auto",
//       backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
//     }),
//     valueContainer: (provided) => ({ ...provided, padding: "2px 8px" }),
//     input: (provided) => ({ ...provided, margin: "0px", padding: "0px" }),
//     indicatorsContainer: (provided) => ({ ...provided, height: "38px" }),
//     placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : null,
//       color: state.isSelected ? "white" : "#212529",
//       ":active": { backgroundColor: !state.isDisabled ? (state.isSelected ? "#0a58ca" : "#dbeafe") : undefined },
//     }),
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//     singleValue: (provided, state) => ({
//       ...provided,
//       color: state.isDisabled ? "#6c757d" : "#212529",
//     }),
//   },
// };

// const AppointmentLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([])
//   const navigate = useNavigate()
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredLetters, setFilteredLetters] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [itemsPerPage, setItemsPerPage] = useState(10)
//   const [isLoading, setIsLoading] = useState(false)
//   const [isLoadingData, setIsLoadingData] = useState(true)
//   const [noDataFound, setNoDataFound] = useState(false)
//   const [sentStatus, setSentStatus] = useState({})
//   const [isDownloading, setIsDownloading] = useState({})
//   const [isSending, setIsSending] = useState({})
  
//   // Modal & Form States
//   const [showModal, setShowModal] = useState(false)
//   const [generationMethod, setGenerationMethod] = useState("custom")
//   const [customContent, setCustomContent] = useState("")
//   const [uploadedFile, setUploadedFile] = useState(null)
//   const [signatureFile, setSignatureFile] = useState(null)
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false)

//   // Filtering Data States
//   const [offerLettersSource, setOfferLettersSource] = useState([]) 
//   const [jobTitles, setJobTitles] = useState([])
//   const [hrList, setHrList] = useState([])

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState("")
//   const [selectedCandidate, setSelectedCandidate] = useState(null)
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])
//   const [showApplicantData, setShowApplicantData] = useState(false)
//   const [address, setAddress] = useState("")
//   const [pinCode, setPinCode] = useState("")
//   const [mobileNumber, setMobileNumber] = useState("")

//   const [initialFormData] = useState({
//     candidateName: "",
//     position: "",
//     date: "",
//     section: "Appointment Letter",
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//     reporting_manager: "",
//     headquarter: "",
//     department: "",
//     workingTerritory: "",
//     joiningDate: "",
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---
//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/");
//       const data = response.data;
      
//       let lettersData = [];
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else {
//         setLetters([]);
//         setNoDataFound(true);
//       }
//     } catch (error) {
//       console.error("Error fetching appointment letters:", error);
//       setLetters([]);
//       setNoDataFound(true);
//     }
//   }, []);

//   const fetchOfferLettersSource = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/letter/");
//       const data = response.data;
      
//       let sourceData = [];
//       if (Array.isArray(data)) {
//         sourceData = data;
//       } else if (data && Array.isArray(data.letters)) {
//         sourceData = data.letters;
//       }

//       setOfferLettersSource(sourceData);

//       const uniquePositions = [...new Set(sourceData.map(item => item.position).filter(Boolean))].sort();
//       setJobTitles(uniquePositions);

//     } catch (error) {
//       console.error("Error fetching source offer letters:", error);
//       setOfferLettersSource([]);
//       setJobTitles([]);
//     }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.id] = letter.sent === true || letter.sent === "true";
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//         await Promise.all([fetchLetters(), fetchOfferLettersSource(), fetchHrList()]);
//       } catch (error) {
//         console.error("Error loading initial data:", error);
//         Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//         setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchOfferLettersSource, fetchHrList]);


//   // --- Logic & Handlers ---
//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//   const sendEmail = useCallback(async (candidateName, pdfPath, letterType, pk) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
    
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsSending(prev => ({ ...prev, [pk]: true }));
//     try {
//       await axios.post("https://raasbackend.vetrinahealthcare.com/send_appointment_letter_email/", {
//         candidate_name: candidateName,
//         pdf_path: cleanPath,
//         letter_type: letterType || "Appointment Letter",
//         letter_id: pk,
//       });
//       Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
      
//       setLetters(prev => prev.map(l => l.id === pk ? {...l, sent: true} : l));
//       setSentStatus(prev => ({ ...prev, [pk]: true }));

//     } catch (error) {
//       console.error("Error sending email:", error);
//       Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true });
//     }
//     finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
    
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsDownloading(prev => ({ ...prev, [pk]: true }));
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_appointment_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
//       const link = document.createElement("a");
//       link.href = url;
//       const filename = `${candidateName}_${letterType || 'Appointment'}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//       link.setAttribute("download", filename);
//       document.body.appendChild(link); link.click(); document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//     finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({ ...prevState, [name]: value }));
//   }, []);

//   const handleHrChange = useCallback((selectedOption) => {
//     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//     setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//   }, [hrList]);

//   const handleFileChange = useCallback((e) => {
//     setUploadedFile(e.target.files[0] || null);
//   }, []);

//   const handleSignatureFileChange = useCallback(async (e) => {
//     const file = e.target.files[0] || null;
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//       if (e?.target) e.target.value = null;
//       return;
//     }
//     setIsProcessingSignature(true);
//     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//     try {
//       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//       const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//       setSignatureFile(processedFile);
//       const reader = new FileReader();
//       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//       reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//       reader.readAsDataURL(processedBlob);
//     } catch (error) {
//       console.error("Error removing background:", error);
//       Swal.fire({ icon: "error", title: "Background Removal Failed", text: "Could not process signature." });
//       setSignatureFile(null); setSignaturePreviewUrl(null);
//       if (e?.target) e.target.value = null;
//     } finally {
//       setIsProcessingSignature(false);
//       if (Swal.isVisible()) { Swal.close(); }
//     }
//   }, []);

//   // --- Handle Job Title Change ---
//   const handleJobTitleChange = useCallback((event) => {
//     const title = event.target.value;
//     setSelectedJobTitle(title);
//     setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//     setFormData(prev => ({ ...initialFormData, position: title || '', generationMethod: prev.generationMethod }));
    
//     if (title && offerLettersSource.length > 0) {
//       const relevantOffers = offerLettersSource.filter(offer => offer.position === title);
//       const uniqueCandidates = [];
//       const seenUserIds = new Set();

//       relevantOffers.forEach(offer => {
//           if (!seenUserIds.has(offer.user_id)) {
//               seenUserIds.add(offer.user_id);
//               uniqueCandidates.push({
//                   value: offer.user_id,
//                   label: offer.candidate_name,
//                   fullName: offer.candidate_name,
//                   offerData: offer
//               });
//           }
//       });

//       uniqueCandidates.sort((a, b) => a.label.localeCompare(b.label));
//       setFilteredCandidateOptions(uniqueCandidates);
//     }
//   }, [offerLettersSource, initialFormData]);

//   // --- Handle Candidate Change ---
//   const handleCandidateChange = useCallback((selectedOption) => {
//     setSelectedCandidate(selectedOption);
//     const applicantId = selectedOption?.value || null;
//     const applicantName = selectedOption?.fullName || selectedOption?.label || "";
    
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
    
//     setFormData(prevState => ({
//       ...prevState,
//       candidateName: applicantName,
//       user_id: applicantId
//     }));

//     if (selectedOption && selectedOption.offerData) {
//         const { applicant_address, applicant_phone } = selectedOption.offerData;
//         const fetchedAddress = applicant_address || "N/A";
//         const fetchedMobile = applicant_phone || "N/A";
//         const pinMatch = fetchedAddress.match(/\b\d{6}\b/);
//         const fetchedPinCode = pinMatch ? pinMatch[0] : "";

//         setAddress(fetchedAddress);
//         setPinCode(fetchedPinCode);
//         setMobileNumber(fetchedMobile);
//         setShowApplicantData(true);
        
//         setFormData(prevState => ({
//             ...prevState,
//             address: fetchedAddress,
//             pinCode: fetchedPinCode,
//             mobileNumber: fetchedMobile
//         }));
//     }
//   }, []);

//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//     if (!selectedJobTitle) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }

//     let endpoint = "";
//     const payload = new FormData();
//     let headers = { 'Content-Type': 'multipart/form-data' };
//     let navigateTo = null;
//     let navigateState = null;
//     let successMessage = "";

//     try {
//       if (generationMethod === "custom") {
//         if (!formData.date) { Swal.fire("Validation Error", "Please select a Letter Date.", "warning"); setIsLoading(false); return; }
//         if (!customContent.trim()) { Swal.fire("Validation Error", "Please enter custom letter content.", "warning"); setIsLoading(false); return; }
        
//         endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/";
        
//         payload.append('method', "Appointment Letter");
//         payload.append('user_id', formData.user_id);
//         payload.append('reportingManager', formData.reporting_manager);
//         payload.append('department', formData.department);
//         payload.append('headquarter', formData.headquarter);
//         payload.append('workingTerritory', formData.workingTerritory);
//         payload.append('customContent', customContent);
//         payload.append('date', formData.date);
        
//         // FIXED: Using 'candidate_name' (snake_case) ensures backend stores the name correctly
//         payload.append('candidate_name', formData.candidateName);
        
//         if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//         if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//         const response = await axios.post(endpoint, payload, { headers });
//         const createdLetterId = response.data.letter_id;
        
//         successMessage = response.data.message || `Custom Appointment Letter record created.`;
//         navigateTo = "/appointmentletter";
//         navigateState = {
//           ...formData,
//           customContent,
//           section: "Appointment Letter",
//           generationMethod: 'custom',
//           signaturePreviewUrl,
//           jobTitle: selectedJobTitle,
//           letter_id: createdLetterId,
//         };

//       } else if (generationMethod === "upload") {
//         if (!uploadedFile) { Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning"); setIsLoading(false); return; }
//         if (uploadedFile.type !== 'application/pdf') { Swal.fire("Validation Error", "Invalid file type. Please upload a PDF.", "warning"); setIsLoading(false); return; }

//         endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/";
        
//         payload.append('method', "Appointment Letter");
//         payload.append('jobTitle', selectedJobTitle);
//         payload.append('candidate', formData.candidateName);
//         payload.append('upload_pdf', uploadedFile);
//         payload.append('user_id', formData.user_id);

//         const response = await axios.post(endpoint, payload, { headers });
//         successMessage = response.data.message || `Existing Appointment Letter uploaded.`;
//         navigateTo = null;
//         navigateState = null;

//       } else { throw new Error("Invalid generation method selected."); }

//       Swal.fire({
//         title: "Success!", text: successMessage, icon: "success",
//         timer: navigateTo ? 1500 : 2500,
//         timerProgressBar: true, showConfirmButton: false,
//       }).then(() => {
//         handleCloseModal();
//         fetchLetters();
//         if (navigateTo) {
//           navigate(navigateTo, { state: navigateState });
//         }
//       });

//     } catch (error) {
//       console.error(`Error during ${generationMethod} process:`, error);
//       let errorMsg = error.message;
//       if (error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//       Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//     } finally {
//       setIsLoading(false);
//     }
//   }, [formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters]);

//   const handleOpenModal = useCallback(() => {
//     setSelectedJobTitle(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null);
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
//     setGenerationMethod("custom"); setCustomContent(""); setUploadedFile(null);
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//     const fileInputSignatureCustom = document.getElementById('signatureImageFileCustom'); if (fileInputSignatureCustom) fileInputSignatureCustom.value = null;
//     setShowModal(true);
//   }, [initialFormData]);

//   const handleCloseModal = useCallback(() => { setShowModal(false); }, []);

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//     const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//     try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//   };
//   const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//   const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//   const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//   const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//             <Container fluid className="p-0">
//               <Card className="shadow-sm border-0 h-100">
//                 <Card.Header style={styles.cardHeader}>
//                   <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
//                   <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                     {isLoadingData ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />) : (<FaPlus className="me-1" />)}
//                     Create Appointment Letter
//                   </Button>
//                 </Card.Header>

//                 <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                   <Row className="mb-4 flex-shrink-0">
//                     <Col md={7} lg={5}>
//                       <InputGroup size="sm">
//                         <Form.Control type="search" placeholder="Search by Candidate, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                         <InputGroup.Text><FaSearch /></InputGroup.Text>
//                       </InputGroup>
//                     </Col>
//                   </Row>

//                   <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                     <Table hover responsive className="align-middle mb-0 small">
//                       <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                         <tr>
//                           <th style={{ width: '5%' }}>#</th>
//                           <th style={{ width: '25%' }}>Candidate Name</th>
//                           <th style={{ width: '15%' }}>Department</th>
//                           <th style={{ width: '10%' }}>Method</th>
//                           <th style={{ width: '10%' }} className="text-center">Download</th>
//                           <th style={{ width: '20%' }}>Generated On</th>
//                           <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                           <th style={{ width: '5%' }} className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoadingData ? (
//                           <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading appointment letters...</p></td></tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((letter, index) => {
//                             const globalIndex = indexOfFirstItem + index;
//                             const pk = letter.id; 
//                             const isSent = sentStatus[pk];
//                             const method = letter.generation_method || 'N/A';
//                             const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                             const methodBg = method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                            
//                             return (
//                               <tr key={pk}>
//                                 <td>{globalIndex + 1}</td>
//                                 <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                 <td>{letter.department || <span className="text-muted">N/A</span>}</td>
//                                 <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, "Appointment Letter")} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                     {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                   </Button>
//                                 </td>
//                                 <td>{formatDateTime(letter.created_at)}</td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, "Appointment Letter", pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                     {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                   </Button>
//                                 </td>
//                                 <td className="text-center">
//                                   {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No appointment letters have been generated yet."}</td></tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                     <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                       <div className="d-flex align-items-center">
//                         <span className="me-2 text-muted small">Rows:</span>
//                         <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                           <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                         </Form.Select>
//                         <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                       </div>
//                       <Pagination size="sm" className="mb-0">
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         <Pagination.Item active>{currentPage}</Pagination.Item>
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                         {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                         {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                       </Pagination>
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//           <Modal.Header closeButton>
//             <Modal.Title style={styles.gradientText}>
//               {generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               {generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               Create New Appointment Letter
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//             <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                 <Row>
//                   <Col md={6} lg={4} className="mb-3">
//                     <Form.Group controlId="generationMethod">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                         <option value="custom">Write Custom Content</option>
//                         <option value="upload">Upload Existing PDF</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="jobTitleSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
//                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
//                         <option value="">-- Select Job --</option>
//                         {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                       </Form.Select>
//                       {!isLoadingData && jobTitles.length === 0 && <Form.Text className="text-danger small">No job titles loaded.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="candidateNameSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                       <Select
//                         styles={styles.reactSelectStyles}
//                         options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                         placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                         isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                         noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                       />
//                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 {showApplicantData && (
//                   <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                     <FaInfoCircle className="me-1" /> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                   </Alert>
//                 )}
//               </div>

//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod === "custom" ? "Custom Content" : "Upload PDF"})</h5>

//                 {generationMethod === 'custom' && (
//                   <>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="dateCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="hrNameSelectCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                           <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="reportingManagerCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
//                           <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's name" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="departmentCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Department</Form.Label>
//                           <Form.Control type="text" name="department" value={formData.department} onChange={handleChange} placeholder="e.g., Engineering" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="headquarterCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Headquarter</Form.Label>
//                           <Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Pune" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="workingTerritoryCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Working Territory</Form.Label>
//                           <Form.Control type="text" name="workingTerritory" value={formData.workingTerritory} onChange={handleChange} placeholder="e.g., Maharashtra" size="sm" />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Form.Group className="mb-3" controlId="customContentArea">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                       <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the appointment letter here..." required />
//                     </Form.Group>
//                     <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                       <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFileCustom" disabled={isProcessingSignature} size="sm" />
//                       {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                       {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                       {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                     </Form.Group>
//                   </>
//                 )}
//                 {generationMethod === 'upload' && (
//                   <>
//                     <Alert variant="info" className="d-flex align-items-center small">
//                       <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em" />
//                       Upload the final, signed appointment letter as a PDF document. It will be stored and associated with the selected candidate.
//                     </Alert>
//                     <Form.Group controlId="uploadedFile" className="mb-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                       <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm" id="uploadedFile" />
//                       {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                     </Form.Group>
//                   </>
//                 )}
//               </div>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer className="bg-light border-top">
//             <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//             <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//               {isLoading || isProcessingSignature ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//               ) : generationMethod === 'upload' ? (<><FaFilePdf className="me-1" /> Upload {formData.section}</>
//               ) : (
//                 <><FaSignature className="me-1" /> Save & Preview {formData.section}</>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default AppointmentLetterGenerator;


// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { FcApproval, FcHighPriority } from "react-icons/fc";
// import Select from "react-select";
// import { removeBackground } from "@imgly/background-removal";
// import {
//   FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck,
//   FaSignature, FaFilePdf, FaEdit, FaInfoCircle,
// } from "react-icons/fa";

// import "bootstrap/dist/css/bootstrap.min.css";

// // --- Professional Styles ---
// const styles = {
//   gradientText: {
//     background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: "600",
//   },
//   cardHeader: {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #e9ecef",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "1rem 1.5rem",
//   },
//   modalSection: {
//     border: "1px solid #dee2e6",
//     borderRadius: "0.375rem",
//     padding: "1.5rem",
//     marginBottom: "1.5rem",
//     backgroundColor: "#f8f9fa",
//   },
//   signaturePreview: {
//     maxWidth: "200px",
//     maxHeight: "100px",
//     border: "2px dashed #ced4da",
//     padding: "10px",
//     borderRadius: "0.375rem",
//     backgroundColor: "#ffffff",
//     marginTop: "15px",
//     display: "block",
//     marginLeft: "auto",
//     marginRight: "auto",
//     objectFit: "contain",
//   },
//   pageWrapper: {
//     display: "flex",
//     flexDirection: "column",
//     height: "100vh",
//     overflow: "hidden",
//   },
//   contentWrapper: {
//     display: "flex",
//     flexGrow: 1,
//     overflow: "hidden",
//   },
//   mainContentArea: {
//     flexGrow: 1,
//     overflowY: "auto",
//     padding: "1.5rem 2rem",
//     backgroundColor: "#f4f7fc",
//     height: "calc(100vh - 56px)",
//   },
//   reactSelectStyles: {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
//       "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
//       minHeight: "38px",
//       height: "auto",
//       backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
//     }),
//     valueContainer: (provided) => ({ ...provided, padding: "2px 8px" }),
//     input: (provided) => ({ ...provided, margin: "0px", padding: "0px" }),
//     indicatorsContainer: (provided) => ({ ...provided, height: "38px" }),
//     placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : null,
//       color: state.isSelected ? "white" : "#212529",
//       ":active": { backgroundColor: !state.isDisabled ? (state.isSelected ? "#0a58ca" : "#dbeafe") : undefined },
//     }),
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//     singleValue: (provided, state) => ({
//       ...provided,
//       color: state.isDisabled ? "#6c757d" : "#212529",
//     }),
//   },
// };

// const AppointmentLetterGenerator = () => {
//   // --- States ---
//   const [letters, setLetters] = useState([])
//   const navigate = useNavigate()
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredLetters, setFilteredLetters] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [itemsPerPage, setItemsPerPage] = useState(10)
//   const [isLoading, setIsLoading] = useState(false)
//   const [isLoadingData, setIsLoadingData] = useState(true)
//   const [noDataFound, setNoDataFound] = useState(false)
//   const [sentStatus, setSentStatus] = useState({})
//   const [isDownloading, setIsDownloading] = useState({})
//   const [isSending, setIsSending] = useState({})
  
//   // Modal & Form States
//   const [showModal, setShowModal] = useState(false)
//   const [generationMethod, setGenerationMethod] = useState("custom")
//   const [customContent, setCustomContent] = useState("")
//   const [uploadedFile, setUploadedFile] = useState(null)
//   const [signatureFile, setSignatureFile] = useState(null)
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false)

//   // Filtering Data States
//   const [jobApplications, setJobApplications] = useState([])
//   const [applicants, setApplicants] = useState([])
//   const [jobTitles, setJobTitles] = useState([])
//   const [hrList, setHrList] = useState([])

//   // Selection States
//   const [selectedJobTitle, setSelectedJobTitle] = useState("")
//   const [selectedCandidate, setSelectedCandidate] = useState(null)
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])
//   const [showApplicantData, setShowApplicantData] = useState(false)
//   const [address, setAddress] = useState("")
//   const [pinCode, setPinCode] = useState("")
//   const [mobileNumber, setMobileNumber] = useState("")

//   const [initialFormData] = useState({
//     candidateName: "",
//     position: "",
//     date: "",
//     section: "Appointment Letter",
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//     reporting_manager: "",
//     headquarter: "",
//     department: "",
//     workingTerritory: "", // Added as per payload requirement
//     joiningDate: "",
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching ---
//   const fetchLetters = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/");
//       const data = response.data;
      
//       // Handle response based on structure provided (Array of objects)
//       let lettersData = [];
//       if (Array.isArray(data)) {
//           lettersData = data;
//       } else if (data && Array.isArray(data.letters)) {
//           lettersData = data.letters;
//       }

//       if (lettersData.length > 0) {
//         setLetters(lettersData);
//         initializeSentStatus(lettersData);
//         setNoDataFound(false);
//       } else {
//         setLetters([]);
//         setNoDataFound(true);
//       }
//     } catch (error) {
//       console.error("Error fetching appointment letters:", error);
//       setLetters([]);
//       setNoDataFound(true);
//     }
//   }, []);

//   const fetchJobApplications = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/job_applications_for_letter/");
//       const data = response.data;
//       if (data && Array.isArray(data)) {
//         setJobApplications(data);
//         const uniqueTitles = [...new Set(data.map(app => app.job_title).filter(Boolean))].sort();
//         setJobTitles(uniqueTitles);
//       } else { setJobApplications([]); setJobTitles([]); }
//     } catch (error) { console.error("Error fetching job applications:", error); }
//   }, []);

//   const fetchApplicants = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setApplicants(data); }
//       else { setApplicants([]); }
//     } catch (error) { console.error("Error fetching applicants:", error); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/");
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); }
//   }, []);

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       // Based on JSON: "sent": false (boolean)
//       initialSentStatus[letter.id] = letter.sent === true || letter.sent === "true";
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//         await Promise.all([fetchLetters(), fetchJobApplications(), fetchApplicants(), fetchHrList()]);
//       } catch (error) {
//         console.error("Error loading initial data:", error);
//         Swal.fire("Load Error", "Failed to load necessary data.", "error");
//       } finally {
//         setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchJobApplications, fetchApplicants, fetchHrList]);


//   // --- Logic & Handlers ---
//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       // Adjust field access based on the flat JSON structure provided
//       const candidateMatches = letter.candidate_name?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//   const sendEmail = useCallback(async (candidateName, pdfPath, letterType, pk) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
    
//     // Fix path if it starts with slash
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsSending(prev => ({ ...prev, [pk]: true }));
//     try {
//       await axios.post("https://raasbackend.vetrinahealthcare.com/send_appointment_letter_email/", {
//         candidate_name: candidateName,
//         pdf_path: cleanPath,
//         letter_type: letterType || "Appointment Letter",
//         letter_id: pk,
//       });
//       Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
      
//       // Optimistic update
//       setLetters(prev => prev.map(l => l.id === pk ? {...l, sent: true} : l));
//       setSentStatus(prev => ({ ...prev, [pk]: true }));

//     } catch (error) {
//       console.error("Error sending email:", error);
//       Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true });
//     }
//     finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
    
//     let cleanPath = pdfPath;
//     if (cleanPath.startsWith('/')) cleanPath = cleanPath.substring(1);

//     setIsDownloading(prev => ({ ...prev, [pk]: true }));
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_appointment_pdf/?pdfPath=${encodeURIComponent(cleanPath)}`, { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
//       const link = document.createElement("a");
//       link.href = url;
//       const filename = `${candidateName}_${letterType || 'Appointment'}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//       link.setAttribute("download", filename);
//       document.body.appendChild(link); link.click(); document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//     finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({ ...prevState, [name]: value }));
//   }, []);

//   const handleHrChange = useCallback((selectedOption) => {
//     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//     setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//   }, [hrList]);

//   const handleFileChange = useCallback((e) => {
//     setUploadedFile(e.target.files[0] || null);
//   }, []);

//   const handleSignatureFileChange = useCallback(async (e) => {
//     const file = e.target.files[0] || null;
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//       if (e?.target) e.target.value = null;
//       return;
//     }
//     setIsProcessingSignature(true);
//     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//     try {
//       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//       const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//       setSignatureFile(processedFile);
//       const reader = new FileReader();
//       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//       reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//       reader.readAsDataURL(processedBlob);
//     } catch (error) {
//       console.error("Error removing background:", error);
//       Swal.fire({ icon: "error", title: "Background Removal Failed", text: "Could not process signature." });
//       setSignatureFile(null); setSignaturePreviewUrl(null);
//       if (e?.target) e.target.value = null;
//     } finally {
//       setIsProcessingSignature(false);
//       if (Swal.isVisible()) { Swal.close(); }
//     }
//   }, []);

//   const handleJobTitleChange = useCallback((event) => {
//     const title = event.target.value;
//     setSelectedJobTitle(title);
//     setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//     setFormData(prev => ({ ...initialFormData, position: title || '', generationMethod: prev.generationMethod }));
    
//     if (title && jobApplications.length > 0 && applicants.length > 0) {
//       const relevantApplications = jobApplications.filter(app => app.job_title === title);
//       const applicantIds = [...new Set(relevantApplications.map(app => app.applicant))];
//       const matchingApplicants = applicants.filter(applicant => applicantIds.includes(applicant.id));
//       const options = matchingApplicants.map(applicant => ({
//         value: applicant.id,
//         label: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''} (${applicant.email || `ID: ${applicant.id}`})`.replace(/\s+/g, ' ').trim(),
//         fullName: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''}`.replace(/\s+/g, ' ').trim() || `Applicant ${applicant.id}`
//       })).sort((a, b) => a.label.localeCompare(b.label));
//       setFilteredCandidateOptions(options);
//     }
//   }, [jobApplications, applicants, initialFormData]);

//   const handleCandidateChange = useCallback((selectedOption) => {
//     setSelectedCandidate(selectedOption);
//     const applicantId = selectedOption?.value || null;
//     const applicantName = selectedOption?.fullName || selectedOption?.label || "";
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
    
//     setFormData(prevState => ({
//       ...prevState,
//       candidateName: applicantName,
//       user_id: applicantId
//     }));

//     if (applicantId) {
//       const applicantData = applicants.find(app => app.id === applicantId);
//       if (applicantData) {
//         const fetchedAddress = applicantData.district || "";
//         const fetchedPinCode = applicantData.zip_code || "";
//         const fetchedMobile = applicantData.phone || "";
//         setAddress(fetchedAddress); setPinCode(fetchedPinCode); setMobileNumber(fetchedMobile);
//         setShowApplicantData(true);
//         setFormData(prevState => ({ ...prevState, address: fetchedAddress, pinCode: fetchedPinCode, mobileNumber: fetchedMobile }));
//       }
//     }
//   }, [applicants]);

//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//     if (!selectedJobTitle) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }

//     let endpoint = "";
//     const payload = new FormData();
//     let headers = { 'Content-Type': 'multipart/form-data' };
//     let navigateTo = null;
//     let navigateState = null;
//     let successMessage = "";

//     try {
//       if (generationMethod === "custom") {
//         if (!formData.date) { Swal.fire("Validation Error", "Please select a Letter Date.", "warning"); setIsLoading(false); return; }
//         if (!customContent.trim()) { Swal.fire("Validation Error", "Please enter custom letter content.", "warning"); setIsLoading(false); return; }
        
//         endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/";
        
//         // Payload based on Postman screenshot for custom creation
//         payload.append('method', "Appointment Letter");
//         payload.append('user_id', formData.user_id);
//         payload.append('reportingManager', formData.reporting_manager);
//         payload.append('department', formData.department);
//         payload.append('headquarter', formData.headquarter);
//         payload.append('workingTerritory', formData.workingTerritory);
//         payload.append('customContent', customContent);
//         payload.append('date', formData.date);
//         payload.append('candidate_name', formData.candidateName); // Added for consistency
        
//         if (formData.hr?.id) payload.append('hr_id', formData.hr.id);
//         if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);

//         const response = await axios.post(endpoint, payload, { headers });
//         const createdLetterId = response.data.letter_id;
        
//         successMessage = response.data.message || `Custom Appointment Letter record created.`;
//         navigateTo = "/appointmentletter"; // Assuming this is your preview route
//         navigateState = {
//           ...formData,
//           customContent,
//           section: "Appointment Letter",
//           generationMethod: 'custom',
//           signaturePreviewUrl,
//           jobTitle: selectedJobTitle,
//           letter_id: createdLetterId,
//         };

//       } else if (generationMethod === "upload") {
//         if (!uploadedFile) { Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning"); setIsLoading(false); return; }
//         if (uploadedFile.type !== 'application/pdf') { Swal.fire("Validation Error", "Invalid file type. Please upload a PDF.", "warning"); setIsLoading(false); return; }

//         endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/";
        
//         // Payload based on Postman screenshot for upload
//         payload.append('method', "Appointment Letter");
//         payload.append('jobTitle', selectedJobTitle);
//         payload.append('candidate', formData.candidateName); // Key is 'candidate' per screenshot
//         payload.append('upload_pdf', uploadedFile);          // Key is 'upload_pdf' per screenshot
//         payload.append('user_id', formData.user_id);

//         const response = await axios.post(endpoint, payload, { headers });
//         successMessage = response.data.message || `Existing Appointment Letter uploaded.`;
//         navigateTo = null;
//         navigateState = null;

//       } else { throw new Error("Invalid generation method selected."); }

//       Swal.fire({
//         title: "Success!", text: successMessage, icon: "success",
//         timer: navigateTo ? 1500 : 2500,
//         timerProgressBar: true, showConfirmButton: false,
//       }).then(() => {
//         handleCloseModal();
//         fetchLetters();
//         if (navigateTo) {
//           navigate(navigateTo, { state: navigateState });
//         }
//       });

//     } catch (error) {
//       console.error(`Error during ${generationMethod} process:`, error);
//       let errorMsg = error.message;
//       if (error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//       Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//     } finally {
//       setIsLoading(false);
//     }
//   }, [formData, selectedJobTitle, generationMethod, customContent, uploadedFile, signatureFile, signaturePreviewUrl, navigate, fetchLetters]);

//   const handleOpenModal = useCallback(() => {
//     setSelectedJobTitle(""); setFilteredCandidateOptions([]); setFormData(initialFormData); setSelectedCandidate(null);
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
//     setGenerationMethod("custom"); setCustomContent(""); setUploadedFile(null);
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//     const fileInputSignatureCustom = document.getElementById('signatureImageFileCustom'); if (fileInputSignatureCustom) fileInputSignatureCustom.value = null;
//     setShowModal(true);
//   }, [initialFormData]);

//   const handleCloseModal = useCallback(() => { setShowModal(false); }, []);

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//     const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//     try { return new Date(dateTimeString).toLocaleString('en-US', options); } catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//   };
//   const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//   const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//   const handleItemsPerPageChange = useCallback((e) => { setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1); }, []);
//   const handlePageChange = useCallback((pageNumber) => { setCurrentPage(pageNumber); }, []);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//             <Container fluid className="p-0">
//               <Card className="shadow-sm border-0 h-100">
//                 <Card.Header style={styles.cardHeader}>
//                   <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
//                   <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                     {isLoadingData ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />) : (<FaPlus className="me-1" />)}
//                     Create Appointment Letter
//                   </Button>
//                 </Card.Header>

//                 <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                   <Row className="mb-4 flex-shrink-0">
//                     <Col md={7} lg={5}>
//                       <InputGroup size="sm">
//                         <Form.Control type="search" placeholder="Search by Candidate, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                         <InputGroup.Text><FaSearch /></InputGroup.Text>
//                       </InputGroup>
//                     </Col>
//                   </Row>

//                   <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                     <Table hover responsive className="align-middle mb-0 small">
//                       <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                         <tr>
//                           <th style={{ width: '5%' }}>#</th>
//                           <th style={{ width: '25%' }}>Candidate Name</th>
//                           <th style={{ width: '15%' }}>Department</th>
//                           <th style={{ width: '10%' }}>Method</th>
//                           <th style={{ width: '10%' }} className="text-center">Download</th>
//                           <th style={{ width: '20%' }}>Generated On</th>
//                           <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                           <th style={{ width: '5%' }} className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoadingData ? (
//                           <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading appointment letters...</p></td></tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((letter, index) => {
//                             const globalIndex = indexOfFirstItem + index;
//                             const pk = letter.id; // Corrected from letter.pk based on JSON
//                             const isSent = sentStatus[pk];
//                             const method = letter.generation_method || 'N/A';
//                             const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                             const methodBg = method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
                            
//                             return (
//                               <tr key={pk}>
//                                 <td>{globalIndex + 1}</td>
//                                 <td>{letter.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                 <td>{letter.department || <span className="text-muted">N/A</span>}</td>
//                                 <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.pdf_path, pk, letter.candidate_name, "Appointment Letter")} disabled={isDownloading[pk] || !letter.pdf_path} title={letter.pdf_path ? "Download PDF" : "No PDF available"}>
//                                     {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                   </Button>
//                                 </td>
//                                 <td>{formatDateTime(letter.created_at)}</td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.candidate_name, letter.pdf_path, "Appointment Letter", pk)} disabled={isSending[pk] || isSent || !letter.pdf_path} title={isSent ? "Email Already Sent" : !letter.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                     {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                   </Button>
//                                 </td>
//                                 <td className="text-center">
//                                   {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No appointment letters have been generated yet."}</td></tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                     <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                       <div className="d-flex align-items-center">
//                         <span className="me-2 text-muted small">Rows:</span>
//                         <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                           <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                         </Form.Select>
//                         <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                       </div>
//                       <Pagination size="sm" className="mb-0">
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         <Pagination.Item active>{currentPage}</Pagination.Item>
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                         {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                         {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                       </Pagination>
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//           <Modal.Header closeButton>
//             <Modal.Title style={styles.gradientText}>
//               {generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               {generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               Create New Appointment Letter
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//             <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                 <Row>
//                   <Col md={6} lg={4} className="mb-3">
//                     <Form.Group controlId="generationMethod">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                         <option value="custom">Write Custom Content</option>
//                         <option value="upload">Upload Existing PDF</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="jobTitleSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
//                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
//                         <option value="">-- Select Job --</option>
//                         {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                       </Form.Select>
//                       {!isLoadingData && jobTitles.length === 0 && <Form.Text className="text-danger small">No job titles loaded.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="candidateNameSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                       <Select
//                         styles={styles.reactSelectStyles}
//                         options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                         placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                         isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                         noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                       />
//                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 {showApplicantData && (
//                   <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                     <FaInfoCircle className="me-1" /> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                   </Alert>
//                 )}
//               </div>

//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod === "custom" ? "Custom Content" : "Upload PDF"})</h5>

//                 {generationMethod === 'custom' && (
//                   <>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="dateCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="hrNameSelectCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <small>(Optional)</small></Form.Label>
//                           <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="reportingManagerCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
//                           <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's name" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="departmentCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Department</Form.Label>
//                           <Form.Control type="text" name="department" value={formData.department} onChange={handleChange} placeholder="e.g., Engineering" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="headquarterCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Headquarter</Form.Label>
//                           <Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Pune" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="workingTerritoryCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Working Territory</Form.Label>
//                           <Form.Control type="text" name="workingTerritory" value={formData.workingTerritory} onChange={handleChange} placeholder="e.g., Maharashtra" size="sm" />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Form.Group className="mb-3" controlId="customContentArea">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                       <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the appointment letter here..." required />
//                     </Form.Group>
//                     <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                       <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFileCustom" disabled={isProcessingSignature} size="sm" />
//                       {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                       {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                       {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                     </Form.Group>
//                   </>
//                 )}
//                 {generationMethod === 'upload' && (
//                   <>
//                     <Alert variant="info" className="d-flex align-items-center small">
//                       <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em" />
//                       Upload the final, signed appointment letter as a PDF document. It will be stored and associated with the selected candidate.
//                     </Alert>
//                     <Form.Group controlId="uploadedFile" className="mb-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                       <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm" id="uploadedFile" />
//                       {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                     </Form.Group>
//                   </>
//                 )}
//               </div>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer className="bg-light border-top">
//             <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//             <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//               {isLoading || isProcessingSignature ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//               ) : generationMethod === 'upload' ? (<><FaFilePdf className="me-1" /> Upload {formData.section}</>
//               ) : (
//                 <><FaSignature className="me-1" /> Save & Preview {formData.section}</>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default AppointmentLetterGenerator;



// "use client"

// import { useState, useEffect, useCallback } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"
// import DashNavbar from "./DashNavbar"
// import Sidebar from "./Sidebar"
// import Modal from "react-bootstrap/Modal"
// import Button from "react-bootstrap/Button"
// import { Table, Pagination, Form, Spinner, Alert, Badge, Card, Row, Col, InputGroup, Container } from "react-bootstrap"
// import Swal from "sweetalert2"
// import { FcApproval, FcHighPriority } from "react-icons/fc"
// import Select from "react-select"
// import { removeBackground } from "@imgly/background-removal"
// import {
//   FaPlus, FaSearch, FaDownload, FaPaperPlane, FaCheck,
//   FaSignature, FaFilePdf, FaEdit, FaInfoCircle,
// } from "react-icons/fa"

// import "bootstrap/dist/css/bootstrap.min.css"

// // Professional Styles (same as before)
// const styles = {
//   gradientText: {
//     background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,110,255,1) 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: "600",
//   },
//   cardHeader: {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #e9ecef",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "1rem 1.5rem",
//   },
//   modalSection: {
//     border: "1px solid #dee2e6",
//     borderRadius: "0.375rem",
//     padding: "1.5rem",
//     marginBottom: "1.5rem",
//     backgroundColor: "#f8f9fa",
//   },
//   signaturePreview: {
//     maxWidth: "200px",
//     maxHeight: "100px",
//     border: "2px dashed #ced4da",
//     padding: "10px",
//     borderRadius: "0.375rem",
//     backgroundColor: "#ffffff",
//     marginTop: "15px",
//     display: "block",
//     marginLeft: "auto",
//     marginRight: "auto",
//     objectFit: "contain",
//   },
//   pageWrapper: {
//     display: "flex",
//     flexDirection: "column",
//     height: "100vh",
//     overflow: "hidden",
//   },
//   contentWrapper: {
//     display: "flex",
//     flexGrow: 1,
//     overflow: "hidden",
//   },
//   mainContentArea: {
//     flexGrow: 1,
//     overflowY: "auto",
//     padding: "1.5rem 2rem",
//     backgroundColor: "#f4f7fc",
//     height: "calc(100vh - 56px)",
//   },
//   reactSelectStyles: {
//     control: (provided, state) => ({
//       ...provided,
//       borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
//       boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)" : "none",
//       "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#adb5bd" },
//       minHeight: "38px",
//       height: "auto",
//       backgroundColor: state.isDisabled ? "#e9ecef" : "#fff",
//     }),
//     valueContainer: (provided) => ({ ...provided, padding: "2px 8px" }),
//     input: (provided) => ({ ...provided, margin: "0px", padding: "0px" }),
//     indicatorsContainer: (provided) => ({ ...provided, height: "38px" }),
//     placeholder: (provided) => ({ ...provided, color: "#6c757d" }),
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : null,
//       color: state.isSelected ? "white" : "#212529",
//       ":active": { backgroundColor: !state.isDisabled ? (state.isSelected ? "#0a58ca" : "#dbeafe") : undefined },
//     }),
//     menu: (provided) => ({ ...provided, zIndex: 9999 }),
//     singleValue: (provided, state) => ({
//       ...provided,
//       color: state.isDisabled ? "#6c757d" : "#212529",
//     }),
//   },
// };

// const AppointmentLetterGenerator = () => {
//   // States
//   const [letters, setLetters] = useState([])
//   const navigate = useNavigate()
//   const [searchQuery, setSearchQuery] = useState("")
//   const [filteredLetters, setFilteredLetters] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [itemsPerPage, setItemsPerPage] = useState(10)
//   const [isLoading, setIsLoading] = useState(false)
//   const [isLoadingData, setIsLoadingData] = useState(true)
//   const [noDataFound, setNoDataFound] = useState(false)
//   const [sentStatus, setSentStatus] = useState({})
//   const [isDownloading, setIsDownloading] = useState({})
//   const [isSending, setIsSending] = useState({})
//   const [address, setAddress] = useState("")
//   const [pinCode, setPinCode] = useState("")
//   const [mobileNumber, setMobileNumber] = useState("")
//   const [showApplicantData, setShowApplicantData] = useState(false)
//   const [hrList, setHrList] = useState([])
//   const [showModal, setShowModal] = useState(false)
//   const [selectedCandidate, setSelectedCandidate] = useState(null)
//   const [generationMethod, setGenerationMethod] = useState("custom") // Default to 'custom'
//   const [customContent, setCustomContent] = useState("")
//   const [uploadedFile, setUploadedFile] = useState(null)
//   const [signatureFile, setSignatureFile] = useState(null)
//   const [signaturePreviewUrl, setSignaturePreviewUrl] = useState(null)
//   const [isProcessingSignature, setIsProcessingSignature] = useState(false)
//   const [jobApplications, setJobApplications] = useState([])
//   const [applicants, setApplicants] = useState([])
//   const [jobTitles, setJobTitles] = useState([])
//   const [selectedJobTitle, setSelectedJobTitle] = useState("")
//   const [filteredCandidateOptions, setFilteredCandidateOptions] = useState([])

//   const [initialFormData] = useState({
//     candidateName: "",
//     position: "",
//     date: "",
//     section: "Appointment Letter", // Fixed for this component
//     address: "",
//     pinCode: "",
//     mobileNumber: "",
//     hr: null,
//     user_id: null,
//     reporting_manager: "",
//     headquarter: "",
//     department: "",
//     joiningDate: "",
//   });
//   const [formData, setFormData] = useState(initialFormData);

//   // --- Data Fetching Callbacks ---
//   const fetchLetters = useCallback(async () => {
//     // setIsLoadingData(true); // Moved to main useEffect
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/get_appointment_letters/"); // API FOR APPOINTMENT LETTERS
//       const data = response.data;
//       if (data && Array.isArray(data.letters)) {
//         setLetters(data.letters);
//         initializeSentStatus(data.letters);
//         setNoDataFound(data.letters.length === 0);
//       } else {
//         console.error("Invalid appointment letters data format:", data);
//         setLetters([]); setNoDataFound(true);
//       }
//     } catch (error) {
//       console.error("Error fetching appointment letters:", error);
//       setLetters([]); setNoDataFound(true);
//       Swal.fire("Error", "Could not fetch appointment letters.", "error");
//     }
//     // finally { setIsLoadingData(false); } // Moved
//   }, []);

//   // ========================================================================
//   // ===== THESE APIs ARE KEPT AS IS FROM OFFER LETTER GENERATOR =========
//   // ========================================================================
//   const fetchJobApplications = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/job_applications_for_letter/"); // KEPT AS IS
//       const data = response.data;
//       if (data && Array.isArray(data)) {
//         setJobApplications(data);
//         const uniqueTitles = [...new Set(data.map(app => app.job_title).filter(Boolean))].sort();
//         setJobTitles(uniqueTitles);
//       } else { console.error("Invalid job applications data format:", data); setJobApplications([]); setJobTitles([]); }
//     } catch (error) { console.error("Error fetching job applications:", error); setJobApplications([]); setJobTitles([]); Swal.fire("Error", "Could not fetch job application data.", "error"); }
//   }, []);

//   const fetchApplicants = useCallback(async () => {
//     try {
//       //  const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants_not_offered/"); // KEPT AS IS - Review if this is correct for appointment letters
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/applicants/"); // KEPT AS IS - Review if this is correct for appointment letters

//       const data = response.data;
//       if (data && Array.isArray(data)) { setApplicants(data); }
//       else { console.error("Invalid applicants data format for appointment:", data); setApplicants([]); }
//     } catch (error) { console.error("Error fetching applicants for appointment:", error); setApplicants([]); Swal.fire("Error", "Could not fetch applicant data.", "error"); }
//   }, []);

//   const fetchHrList = useCallback(async () => {
//     try {
//       const response = await axios.get("https://raasbackend.vetrinahealthcare.com/hr-list/"); // KEPT AS IS
//       const data = response.data;
//       if (data && Array.isArray(data)) { setHrList(data); }
//       else { console.error("Invalid HR list data format:", data); setHrList([]); }
//     } catch (error) { console.error("Error fetching HR list:", error); setHrList([]); }
//   }, []);
//   // ========================================================================
//   // ========================================================================

//   const initializeSentStatus = useCallback((lettersData) => {
//     const initialSentStatus = {};
//     lettersData.forEach((letter) => {
//       initialSentStatus[letter.pk] = letter.fields.sent == 1;
//     });
//     setSentStatus(initialSentStatus);
//   }, []);

//   useEffect(() => {
//     const loadInitialData = async () => {
//       setIsLoadingData(true);
//       try {
//         console.log("Loading initial data for Appointment Letters...");
//         await Promise.all([fetchLetters(), fetchJobApplications(), fetchApplicants(), fetchHrList()]);
//         console.log("Initial data for Appointment Letters loaded.");
//       } catch (error) {
//         console.error("Error during initial data fetch for Appointment Letters:", error);
//         Swal.fire("Load Error", "Failed to load necessary data. Please refresh the page.", "error");
//       } finally {
//         setIsLoadingData(false);
//       }
//     };
//     loadInitialData();
//   }, [fetchLetters, fetchJobApplications, fetchApplicants, fetchHrList]);


//   const applySearchAndPagination = useCallback(() => {
//     let filteredData = letters.filter((letter) => {
//       const searchLower = searchQuery.toLowerCase();
//       const candidateMatches = letter.fields.candidate_name?.toLowerCase().includes(searchLower);
//       const typeMatches = letter.fields.LetterType?.toLowerCase().includes(searchLower);
//       const methodMatches = letter.fields.generation_method?.toLowerCase().includes(searchLower);
//       return candidateMatches || typeMatches || methodMatches;
//     });
//     setNoDataFound(filteredData.length === 0 && letters.length > 0 && !searchQuery);
//     setFilteredLetters(filteredData);
//   }, [letters, searchQuery]);

//   useEffect(() => {
//     applySearchAndPagination();
//     const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);
//     if (currentPage > totalPages && totalPages > 0) { setCurrentPage(totalPages); }
//     else if (filteredLetters.length > 0 && currentPage < 1) { setCurrentPage(1); }
//     else if (filteredLetters.length === 0) { setCurrentPage(1); }
//   }, [filteredLetters, currentPage, itemsPerPage, applySearchAndPagination]);

//   const sendEmail = useCallback(async (candidateName, pdfPath, letterType, pk) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to send.", "info"); return; }
//     setIsSending(prev => ({ ...prev, [pk]: true }));
//     try {
//       await axios.post("https://raasbackend.vetrinahealthcare.com/send_appointment_letter_email/", { // API FOR APPOINTMENT
//         candidate_name: candidateName, pdf_path: pdfPath, letter_type: letterType,
//         letter_id: pk,
//       });
//       Swal.fire({ icon: "success", title: "Email Sent!", timer: 1500, showConfirmButton: false, timerProgressBar: true });
//       setSentStatus(prev => ({ ...prev, [pk]: true }));
//       // Assuming send_appointment_letter_email updates status. If not, use:
//       // await axios.put(`https://raasbackend.vetrinahealthcare.com/update_appointment_sent_status/${pk}/`, { sent: 1 });
//       fetchLetters();
//     } catch (error) {
//       console.error("Error sending appointment email:", error);
//       Swal.fire({ icon: "error", title: "Email Not Sent!", text: error.response?.data?.error || "An error occurred.", timer: 4000, showConfirmButton: true });
//     }
//     finally { setIsSending(prev => ({ ...prev, [pk]: false })); }
//   }, [fetchLetters]);

//   const downloadPdf = useCallback(async (pdfPath, pk, candidateName, letterType) => {
//     if (!pdfPath) { Swal.fire("Info", "No PDF available to download.", "info"); return; }
//     setIsDownloading(prev => ({ ...prev, [pk]: true }));
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/download_appointment_pdf/?pdfPath=${encodeURIComponent(pdfPath)}`, { responseType: "blob" }); // GENERIC API
//       const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
//       const link = document.createElement("a");
//       link.href = url;
//       const filename = `${candidateName}_${letterType}.pdf`.replace(/[\s/\\?%*:|"<>]/g, '_');
//       link.setAttribute("download", filename);
//       document.body.appendChild(link); link.click(); document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//     } catch (error) { console.error("Error downloading PDF:", error); Swal.fire("Error", "Could not download PDF.", "error"); }
//     finally { setIsDownloading(prev => ({ ...prev, [pk]: false })); }
//   }, []);

//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData(prevState => ({ ...prevState, [name]: value }));
//   }, []);

//   const handleHrChange = useCallback((selectedOption) => {
//     const selectedHr = hrList.find(hr => hr.id === selectedOption?.value);
//     setFormData(prevState => ({ ...prevState, hr: selectedHr || null }));
//   }, [hrList]);

//   const handleFileChange = useCallback((e) => {
//     setUploadedFile(e.target.files[0] || null);
//   }, []);

//   const handleSignatureFileChange = useCallback(async (e) => {
//     const file = e.target.files[0] || null;
//     setSignatureFile(null); setSignaturePreviewUrl(null); setIsProcessingSignature(false);
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       Swal.fire("Invalid File", "Please upload a valid image file (e.g., PNG, JPG).", "warning");
//       if (e?.target) e.target.value = null;
//       return;
//     }
//     setIsProcessingSignature(true);
//     Swal.fire({ title: 'Processing Signature', text: 'Removing background...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
//     try {
//       const processedBlob = await removeBackground(file, { output: { format: 'image/png' } });
//       const processedFile = new File([processedBlob], `signature_transparent_${Date.now()}.png`, { type: "image/png" });
//       setSignatureFile(processedFile);
//       const reader = new FileReader();
//       reader.onloadend = () => { setSignaturePreviewUrl(reader.result); Swal.close(); };
//       reader.onerror = (error) => { console.error("Error reading blob:", error); setSignaturePreviewUrl(null); Swal.fire("Error", "Could not preview signature.", "error"); };
//       reader.readAsDataURL(processedBlob);
//     } catch (error) {
//       console.error("Error removing background:", error);
//       Swal.fire({ icon: "error", title: "Background Removal Failed", text: `Could not process signature. Error: ${error?.message || 'Unknown'}. Please try another image.` });
//       setSignatureFile(null); setSignaturePreviewUrl(null);
//       if (e?.target) e.target.value = null;
//     } finally {
//       setIsProcessingSignature(false);
//       if (Swal.isVisible()) { Swal.close(); }
//     }
//   }, []);

//   const handleJobTitleChange = useCallback((event) => {
//     const title = event.target.value;
//     setSelectedJobTitle(title);
//     setSelectedCandidate(null); setFilteredCandidateOptions([]); setShowApplicantData(false);
//     setFormData(prev => ({
//       ...initialFormData,
//       section: "Appointment Letter",
//       generationMethod: prev.generationMethod,
//       position: title || '',
//     }));
//     if (title && jobApplications.length > 0 && applicants.length > 0) {
//       const relevantApplications = jobApplications.filter(app => app.job_title === title);
//       const applicantIds = [...new Set(relevantApplications.map(app => app.applicant))];
//       const matchingApplicants = applicants.filter(applicant => applicantIds.includes(applicant.id));
//       const options = matchingApplicants.map(applicant => ({
//         value: applicant.id,
//         label: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''} (${applicant.email || `ID: ${applicant.id}`})`.replace(/\s+/g, ' ').trim(),
//         fullName: `${applicant.first_name || ''} ${applicant.middle_name || ''} ${applicant.last_name || ''}`.replace(/\s+/g, ' ').trim() || `Applicant ${applicant.id}`
//       })).sort((a, b) => a.label.localeCompare(b.label));
//       setFilteredCandidateOptions(options);
//     }
//   }, [jobApplications, applicants, initialFormData]);

//   const handleCandidateChange = useCallback((selectedOption) => {
//     setSelectedCandidate(selectedOption);
//     const applicantId = selectedOption?.value || null;
//     const applicantName = selectedOption?.fullName || selectedOption?.label || "";
//     setAddress(""); setPinCode(""); setMobileNumber(""); setShowApplicantData(false);
//     setFormData(prevState => ({
//       ...prevState,
//       candidateName: applicantName,
//       user_id: applicantId,
//       address: "", pinCode: "", mobileNumber: ""
//     }));
//     if (applicantId) {
//       const applicantData = applicants.find(app => app.id === applicantId);
//       if (applicantData) {
//         const fetchedAddress = applicantData.district || "";
//         const fetchedPinCode = applicantData.zip_code || "";
//         const fetchedMobile = applicantData.phone || "";
//         setAddress(fetchedAddress); setPinCode(fetchedPinCode); setMobileNumber(fetchedMobile);
//         setShowApplicantData(true);
//         setFormData(prevState => ({ ...prevState, address: fetchedAddress, pinCode: fetchedPinCode, mobileNumber: fetchedMobile }));
//       } else { console.error(`Applicant data not found locally for ID: ${applicantId}`); setShowApplicantData(false); }
//     }
//   }, [applicants]);

//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     if (!formData.candidateName || !formData.user_id) { Swal.fire("Validation Error", "Please select a job title and a candidate.", "warning"); setIsLoading(false); return; }
//     if (!selectedJobTitle) { Swal.fire("Validation Error", "Please select a Job Title.", "warning"); setIsLoading(false); return; }

//     let endpoint = "";
//     const payload = new FormData();
//     let headers = { 'Content-Type': 'multipart/form-data' };
//     let navigateTo = null;
//     let navigateState = null;
//     let successMessage = "";

//     try {
//       if (generationMethod === "custom") {
//         if (!formData.date) { Swal.fire("Validation Error", "Please select a Letter Date.", "warning"); setIsLoading(false); return; }
//         if (!formData.hr) { Swal.fire("Validation Error", "Please select HR for custom letter signature.", "warning"); setIsLoading(false); return; }
//         if (!customContent.trim()) { Swal.fire("Validation Error", "Please enter custom letter content.", "warning"); setIsLoading(false); return; }
//         // Add other appointment-specific field validations here from formData if they are mandatory
//         // e.g., if (!formData.joiningDate) { ... }

//         endpoint = "https://raasbackend.vetrinahealthcare.com/create_custom_appointment_letter/"; // API FOR APPOINTMENT
//         payload.append('candidateName', formData.candidateName);
//         payload.append('user_id', formData.user_id);
//         payload.append('letterType', "Appointment Letter");
//         payload.append('customContent', customContent);
//         payload.append('date', formData.date);
//         payload.append('jobTitle', selectedJobTitle);
//         payload.append('hr_id', formData.hr.id);
//         if (signatureFile) payload.append('signatureImage', signatureFile, signatureFile.name);
//         payload.append('position', formData.position || selectedJobTitle);
//         payload.append('department', formData.department);
//         payload.append('joiningDate', formData.joiningDate);
//         payload.append('reporting_manager', formData.reporting_manager);
//         payload.append('headquarter', formData.headquarter);

//         const response = await axios.post(endpoint, payload, { headers });
//         const createdLetterId = response.data.letter_id;
//         if (!createdLetterId) {
//           throw new Error("Backend did not return a letter_id for the custom appointment letter.");
//         }
//         successMessage = response.data.message || `Custom Appointment Letter record created. Proceed to preview.`;
//         navigateTo = "/appointmentletter"; // Route to AppointmentLetter.js (preview)
//         navigateState = {
//           ...formData,
//           customContent,
//           section: "Appointment Letter",
//           generationMethod: 'custom',
//           signaturePreviewUrl,
//           jobTitle: selectedJobTitle,
//           letter_id: createdLetterId,
//         };

//       } else if (generationMethod === "upload") {
//         if (!uploadedFile) { Swal.fire("Validation Error", "Please select a PDF file to upload.", "warning"); setIsLoading(false); return; }
//         if (uploadedFile.type !== 'application/pdf') { Swal.fire("Validation Error", "Invalid file type. Please upload a PDF.", "warning"); setIsLoading(false); return; }

//         endpoint = "https://raasbackend.vetrinahealthcare.com/upload_existing_appointment_letter/"; // API FOR APPOINTMENT
//         payload.append('candidateName', formData.candidateName);
//         payload.append('user_id', formData.user_id);
//         payload.append('letterType', "Appointment Letter");
//         payload.append('uploadedFile', uploadedFile);
//         payload.append('jobTitle', selectedJobTitle || '');

//         const response = await axios.post(endpoint, payload, { headers });
//         successMessage = response.data.message || `Existing Appointment Letter uploaded.`;
//         navigateTo = null;
//         navigateState = null;

//       } else { throw new Error("Invalid generation method selected."); }

//       Swal.fire({
//         title: "Success!", text: successMessage, icon: "success",
//         timer: navigateTo ? 1500 : 2500,
//         timerProgressBar: true, showConfirmButton: false,
//       }).then(() => {
//         handleCloseModal();
//         fetchLetters();
//         if (navigateTo) {
//           console.log("Navigating to:", navigateTo, "with state:", navigateState);
//           navigate(navigateTo, { state: navigateState });
//         }
//       });

//     } catch (error) {
//       console.error(`Error during ${generationMethod} appointment letter process:`, error);
//       let errorMsg = error.message || `Failed during ${generationMethod} process. Please try again.`;
//       if (error.response) { errorMsg = error.response.data?.error_message || error.response.data?.error || `Server Error: ${error.response.status}`; }
//       else if (error.request) { errorMsg = "Could not connect to the server."; }
//       Swal.fire({ title: "Error!", text: errorMsg, icon: "error" });
//     } finally {
//       setIsLoading(false);
//     }
//   }, [
//     formData, selectedJobTitle, generationMethod, customContent, uploadedFile,
//     signatureFile, signaturePreviewUrl, hrList,
//     navigate, fetchLetters,
//   ]);

//   const handleOpenModal = useCallback(() => {
//     setSelectedJobTitle("");
//     setFilteredCandidateOptions([]);
//     setFormData(initialFormData);
//     setSelectedCandidate(null);
//     setAddress(""); setPinCode(""); setMobileNumber("");
//     setShowApplicantData(false);
//     setGenerationMethod("custom");
//     setCustomContent("");
//     setUploadedFile(null);
//     setSignatureFile(null); setSignaturePreviewUrl(null);
//     setIsProcessingSignature(false);
//     const fileInputUpload = document.getElementById('uploadedFile'); if (fileInputUpload) fileInputUpload.value = null;
//     const fileInputSignatureCustom = document.getElementById('signatureImageFileCustom'); if (fileInputSignatureCustom) fileInputSignatureCustom.value = null;
//     // If you had a template signature input, clear it too, e.g. document.getElementById('signatureImageFileTemplate')
//     setShowModal(true);
//   }, [initialFormData]);

//   const handleCloseModal = useCallback(() => {
//     setShowModal(false);
//   }, []);

//   const formatDateTime = (dateTimeString) => {
//     if (!dateTimeString) return <span className="text-muted small">N/A</span>;
//     const options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true };
//     try { return new Date(dateTimeString).toLocaleString('en-US', options); }
//     catch (e) { return <span className="text-danger small">Invalid Date</span>; }
//   };
//   const formatHrName = (hr) => hr ? `${hr.name} (ID: ${hr.id})` : "";
//   const hrOptions = hrList.map((hr) => ({ value: hr.id, label: formatHrName(hr) }));

//   const handleItemsPerPageChange = useCallback((e) => {
//     setItemsPerPage(parseInt(e.target.value, 10)); setCurrentPage(1);
//   }, []);
//   const handlePageChange = useCallback((pageNumber) => {
//     setCurrentPage(pageNumber);
//   }, []);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredLetters.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredLetters.length / itemsPerPage);

//   return (
//     <>
//       <div style={styles.pageWrapper}>
//         <DashNavbar />
//         <div style={styles.contentWrapper}>
//           <Sidebar />
//           <main style={styles.mainContentArea}>
//             <Container fluid className="p-0">
//               <Card className="shadow-sm border-0 h-100">
//                 <Card.Header style={styles.cardHeader}>
//                   <h1 className="mb-0 h5" style={styles.gradientText}>Appointment Letters Management</h1>
//                   <Button onClick={handleOpenModal} variant="primary" disabled={isLoadingData} size="sm">
//                     {isLoadingData ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />) : (<FaPlus className="me-1" />)}
//                     Create Appointment Letter
//                   </Button>
//                 </Card.Header>

//                 <Card.Body className="d-flex flex-column p-3 p-lg-4" style={{ overflow: 'hidden' }}>
//                   <Row className="mb-4 flex-shrink-0">
//                     <Col md={7} lg={5}>
//                       <InputGroup size="sm">
//                         <Form.Control type="search" placeholder="Search by Candidate, Method..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} disabled={isLoadingData || letters.length === 0} />
//                         <InputGroup.Text><FaSearch /></InputGroup.Text>
//                       </InputGroup>
//                     </Col>
//                   </Row>

//                   <div className="flex-grow-1" style={{ overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem' }}>
//                     <Table hover responsive className="align-middle mb-0 small">
//                       <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fa' }}>
//                         <tr>
//                           <th style={{ width: '5%' }}>#</th>
//                           <th style={{ width: '25%' }}>Candidate Name</th>
//                           <th style={{ width: '15%' }}>Letter Type</th>
//                           <th style={{ width: '10%' }}>Method</th>
//                           <th style={{ width: '10%' }} className="text-center">Download</th>
//                           <th style={{ width: '20%' }}>Generated On</th>
//                           <th style={{ width: '10%' }} className="text-center">Send Email</th>
//                           <th style={{ width: '5%' }} className="text-center">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoadingData ? (
//                           <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading appointment letters...</p></td></tr>
//                         ) : currentItems.length > 0 ? (
//                           currentItems.map((letter, index) => {
//                             const globalIndex = indexOfFirstItem + index;
//                             const pk = letter.pk;
//                             const isSent = sentStatus[pk];
//                             const method = letter.fields.generation_method || 'N/A';
//                             const methodLabel = method.charAt(0).toUpperCase() + method.slice(1);
//                             const methodBg = method === 'custom' ? 'info' : method === 'upload' ? 'secondary' : 'light';
//                             return (
//                               <tr key={pk}>
//                                 <td>{globalIndex + 1}</td>
//                                 <td>{letter.fields.candidate_name || <span className="text-muted">N/A</span>}</td>
//                                 <td>{letter.fields.LetterType || <span className="text-muted">N/A</span>}</td>
//                                 <td><Badge pill bg={methodBg} text={methodBg === 'light' ? 'dark' : 'white'} className="fw-normal">{methodLabel}</Badge></td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant="outline-secondary" onClick={() => downloadPdf(letter.fields.pdf_path, pk, letter.fields.candidate_name, letter.fields.LetterType)} disabled={isDownloading[pk] || !letter.fields.pdf_path} title={letter.fields.pdf_path ? "Download PDF" : "No PDF available"}>
//                                     {isDownloading[pk] ? <Spinner as="span" animation="border" size="sm" /> : <FaDownload />}
//                                   </Button>
//                                 </td>
//                                 <td>{formatDateTime(letter.fields.Time)}</td>
//                                 <td className="text-center">
//                                   <Button size="sm" variant={isSent ? "outline-secondary" : "outline-success"} onClick={() => sendEmail(letter.fields.candidate_name, letter.fields.pdf_path, letter.fields.LetterType, pk)} disabled={isSending[pk] || isSent || !letter.fields.pdf_path} title={isSent ? "Email Already Sent" : !letter.fields.pdf_path ? "Cannot Send (No PDF)" : "Send Email"}>
//                                     {isSending[pk] ? <Spinner as="span" animation="border" size="sm" /> : isSent ? <FaCheck /> : <FaPaperPlane />}
//                                   </Button>
//                                 </td>
//                                 <td className="text-center">
//                                   {isSent ? <FcApproval size="20px" title={`Email Sent`} /> : <FcHighPriority size="20px" title="Email Not Sent" />}
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr><td colSpan="8" className="text-center p-4 text-muted fst-italic">{searchQuery ? "No letters found matching search." : "No appointment letters have been generated yet."}</td></tr>
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {!isLoadingData && filteredLetters.length > itemsPerPage && totalPages > 1 && (
//                     <div className="d-flex justify-content-between align-items-center mt-3 flex-shrink-0 pt-3 border-top">
//                       <div className="d-flex align-items-center">
//                         <span className="me-2 text-muted small">Rows:</span>
//                         <Form.Select size="sm" style={{ width: "auto" }} value={itemsPerPage} onChange={handleItemsPerPageChange}>
//                           <option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="50">50</option>
//                         </Form.Select>
//                         <span className="ms-3 text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredLetters.length)} of {filteredLetters.length} entries</span>
//                       </div>
//                       <Pagination size="sm" className="mb-0">
//                         <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
//                         <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
//                         <Pagination.Item active>{currentPage}</Pagination.Item>
//                         {currentPage < totalPages && <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>{currentPage + 1}</Pagination.Item>}
//                         {currentPage + 1 < totalPages && <Pagination.Ellipsis disabled />}
//                         {currentPage + 1 < totalPages && <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>}
//                         <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
//                         <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
//                       </Pagination>
//                     </div>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Container>
//           </main>
//         </div>

//         <Modal show={showModal} onHide={handleCloseModal} size="xl" backdrop="static" keyboard={false}>
//           <Modal.Header closeButton>
//             <Modal.Title style={styles.gradientText}>
//               {generationMethod === 'custom' && <FaSignature className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               {generationMethod === 'upload' && <FaFilePdf className="me-2 align-middle" style={{ marginTop: '-3px' }} />}
//               Create New Appointment Letter
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto', padding: '1.5rem 2rem' }}>
//             <Form noValidate onSubmit={handleSubmit} id="letterGenerationForm">
//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 1: Select Method & Candidate</h5>
//                 <Row>
//                   <Col md={6} lg={4} className="mb-3">
//                     <Form.Group controlId="generationMethod">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Method</Form.Label>
//                       <Form.Select name="generationMethod" value={generationMethod} onChange={(e) => setGenerationMethod(e.target.value)} required size="sm">
//                         <option value="custom">Write Custom Content</option>
//                         <option value="upload">Upload Existing PDF</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="jobTitleSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Job Title <span className="text-danger">*</span></Form.Label>
//                       <Form.Select value={selectedJobTitle} onChange={handleJobTitleChange} required disabled={isLoadingData || jobTitles.length === 0} size="sm">
//                         <option value="">-- Select Job --</option>
//                         {jobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                       </Form.Select>
//                       {!isLoadingData && jobTitles.length === 0 && <Form.Text className="text-danger small">No job titles loaded.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                   <Col md={6} className="mb-3">
//                     <Form.Group controlId="candidateNameSelect">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Candidate <span className="text-danger">*</span></Form.Label>
//                       <Select
//                         styles={styles.reactSelectStyles}
//                         options={filteredCandidateOptions} value={selectedCandidate} onChange={handleCandidateChange}
//                         placeholder={selectedJobTitle ? "Search or select candidate..." : "Select job title first"}
//                         isSearchable={true} required isDisabled={!selectedJobTitle || filteredCandidateOptions.length === 0 || isLoadingData}
//                         noOptionsMessage={() => selectedJobTitle ? 'No matching candidates' : 'Select job title'}
//                       />
//                       {!selectedJobTitle && <Form.Text className="text-muted small">Select job to enable candidate search.</Form.Text>}
//                       {selectedJobTitle && filteredCandidateOptions.length === 0 && !isLoadingData && <Form.Text className="text-warning small">No applicants found for this job.</Form.Text>}
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 {showApplicantData && (
//                   <Alert variant="secondary" className="p-2 small mt-2 mb-0">
//                     <FaInfoCircle className="me-1" /> <strong>Selected Applicant:</strong> {address || 'N/A'}, {pinCode || 'N/A'}, Ph: {mobileNumber || 'N/A'}
//                   </Alert>
//                 )}
//               </div>

//               <div style={styles.modalSection}>
//                 <h5 className="mb-4 border-bottom pb-2 fw-semibold text-primary">Step 2: Enter Letter Details ({generationMethod === "custom" ? "Custom Content" : "Upload PDF"})</h5>

//                 {generationMethod === 'custom' && (
//                   <>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="dateCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Letter Date <span className="text-danger">*</span></Form.Label>
//                           <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="hrNameSelectCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">HR Name (for signature) <span className="text-danger">*</span></Form.Label>
//                           <Select styles={styles.reactSelectStyles} options={hrOptions} value={formData.hr ? hrOptions.find(o => o.value === formData.hr.id) : null} onChange={handleHrChange} placeholder="Select HR..." isSearchable required />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="joiningDateCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Joining Date</Form.Label>
//                           <Form.Control type="date" name="joiningDate" value={formData.joiningDate} onChange={handleChange} size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="departmentCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Department</Form.Label>
//                           <Form.Control type="text" name="department" value={formData.department} onChange={handleChange} placeholder="e.g., Engineering" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="reportingManagerCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Reporting Manager</Form.Label>
//                           <Form.Control type="text" name="reporting_manager" value={formData.reporting_manager} onChange={handleChange} placeholder="Manager's name" size="sm" />
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} lg={4} className="mb-3">
//                         <Form.Group controlId="headquarterCustom">
//                           <Form.Label className="fw-bold small text-uppercase text-muted">Headquarter</Form.Label>
//                           <Form.Control type="text" name="headquarter" value={formData.headquarter} onChange={handleChange} placeholder="e.g., Mumbai" size="sm" />
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Form.Group className="mb-3" controlId="customContentArea">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Letter Content <span className="text-danger">*</span></Form.Label>
//                       <Form.Control as="textarea" rows={10} value={customContent} onChange={(e) => setCustomContent(e.target.value)} placeholder="Enter the full content of the appointment letter here..." required />
//                     </Form.Group>
//                     <Form.Group controlId="signatureImageFileCustom" className="mb-3 mt-3 border-top pt-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">Signature Image <small>(Optional)</small></Form.Label>
//                       <Form.Control type="file" accept="image/png, image/jpeg, image/webp" onChange={handleSignatureFileChange} id="signatureImageFileCustom" disabled={isProcessingSignature} size="sm" />
//                       {isProcessingSignature && <div className="d-flex align-items-center mt-2 text-primary small"><Spinner as="span" size="sm" className="me-1" />Processing signature...</div>}
//                       {!isProcessingSignature && <Form.Text className="text-muted d-block small mt-1">Upload signature (PNG/JPG). Background auto-removed.</Form.Text>}
//                       {signaturePreviewUrl && !isProcessingSignature && <div className="mt-2 text-center"><img src={signaturePreviewUrl} alt="Signature Preview" style={styles.signaturePreview} /><Form.Text className="text-muted d-block small mt-1">Processed Preview</Form.Text></div>}
//                     </Form.Group>
//                   </>
//                 )}
//                 {generationMethod === 'upload' && (
//                   <>
//                     <Alert variant="info" className="d-flex align-items-center small">
//                       <FaInfoCircle className="me-2 flex-shrink-0" size="1.2em" />
//                       Upload the final, signed appointment letter as a PDF document. It will be stored and associated with the selected candidate.
//                     </Alert>
//                     <Form.Group controlId="uploadedFile" className="mb-3">
//                       <Form.Label className="fw-bold small text-uppercase text-muted">PDF Letter File <span className="text-danger">*</span></Form.Label>
//                       <Form.Control type="file" accept=".pdf" onChange={handleFileChange} required size="sm" id="uploadedFile" />
//                       {uploadedFile && <Form.Text className="text-muted small mt-1">Selected: {uploadedFile.name}</Form.Text>}
//                     </Form.Group>
//                   </>
//                 )}
//               </div>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer className="bg-light border-top">
//             <Button variant="outline-secondary" onClick={handleCloseModal} disabled={isLoading || isProcessingSignature} size="sm"> Cancel </Button>
//             <Button variant="primary" type="submit" form="letterGenerationForm" disabled={isLoading || isProcessingSignature} size="sm">
//               {isLoading || isProcessingSignature ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Processing...</>
//               ) : generationMethod === 'upload' ? (<><FaFilePdf className="me-1" /> Upload {formData.section}</>
//               ) : (
//                 <><FaSignature className="me-1" /> Save & Preview {formData.section}</>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default AppointmentLetterGenerator;